/* eslint-disable max-params */
/* eslint-disable complexity */
/* eslint-disable no-console */
/**
 * 聊天消息输入组件
 * @author sunzhiguang
 * @date 2020/6/16
 */
import React, {
  useCallback,
  useEffect,
  useMemo,
  useReducer,
  useRef,
  useState,
  useContext
} from "react";
import {
  Tooltip,
  message as AntMessage,
  message as toast,
  Menu,
  Button,
  Space,
  Dropdown,
  Popover,
  message
} from "antd";
import IconFont from "@/components/icon";
import { useTranslation, WithTranslation } from "react-i18next";
import "./index.less";
import JEditor from "@/baseComponents/JEditor";
import MentionUserPlugin from "@/baseComponents/JEditor/Plugins/MentionUser";
import { connect } from "dvajs";
import ChatState, { QuickReply, SessionStatusInfo } from "@/types/chat/State";
import {
  AI_CHAT_PREDICT,
  ChatMessage,
  ChatMessageBody,
  ChatMessageType,
  Employee,
  EmployeeAttribute,
  MessageStatus,
  Session,
  SessionType
} from "@/types/chat";
import { isFocusEnv, detectOS, FocusSDK, getClientType, isBjme } from "@/utils";
import PinyinMatch from "pinyin-match";
import { UpLoadImg } from "./UpLoadImg";
import EmojiPopover from "@/components/chat/message/Input/Emoji";
import FontPopover from "@/components/chat/message/Input/FontSelect";
import {
  buildJoyspaceLinkMessageBody,
  buildTextMessageBody,
  getMessageTypeByText,
  initChatMessageInfo,
  isBannedPostGroupSession,
  JouspaceLinkTypeOption,
  employeeToUid,
  buildImageMessageBody,
  extraConvertEmployeeToString,
  HttpCardLinkTypeOption,
  sendMessageBody,
  convertContentToArray,
  nonExistentPageToText,
  handleExpandContent,
  isShowAlias,
  mapRosters,
  isEqualEmployee,
  isCrossPlatformGroupSession,
  isOuterContacts,
  isQuillMsg,
  ALLOW_IMAGE_TYPE,
  getFileDownloadBzType,
  getFileDownloadBzId
} from "@/utils/chat/message";
import { getOrgList, isGroupOrdinary, isGroupOwner, isGroupAdmin } from "@/utils/chat/group";
import MoreDropdown from "./MoreDropdown";
import ChatEvent from "@/components/chat/view/ChatEvent";
import config, { ChatConfig, ConfigEnum, getNetCheckUrl } from "@/config/config";
import chatConfig from "@/components/chat/config";
import { compareLetter, usePrevious } from "@/utils/chat/index";
import Quill, { Sources } from "quill";
import BannedInput from "./BannedInput";
import Context from "@/components/chat/context";
import bus from "@/utils/bus";
import { DownOutlined } from "@/utils/antdIcon";
import { lookup } from "mime-types";
import CopyClipboard from "copy-to-clipboard";
import { getToMergeMessage } from "@/server/im/MessageService";
import ScreenCapture from "./ScreenCapture";
import { openUserSelectionModal } from "@/utils/modals";
import { getAIChatSessionId, isAIChatSession, isAINoticeSession } from "@/utils/chat/session";
import { SelectorMode } from "@jd/focus-desktop-comps/lib/es/UserSelection";
import { debounce, get, omit, cloneDeep } from "lodash";
import { UserModel } from "@/models/user";
import ImService from "@/server/ImService";
import { createUploadTask } from "@/server/FileService";
import log from "@/utils/logger";
import {
  filterDirectory,
  dealImagesData,
  dataURLtoFile,
  filterImages
} from "@/components/chat/utils/image";
import { stickers_sets } from "@/components/chat/utils/stickers-config";
import { analysisLog } from "@/utils/logAnalytics";
import UAParser from "ua-parser-js";
import { nyrssfENStr } from "@/utils/date";
import ComGroupAlias from "@/baseComponents/ComGroupAlias";
import { modifyChatPermission, saveChatRecord, getGroupMemberList } from "@/api/chat";
import complete from "./FontSelect/img/complete.png";
import { getChatMeetingCode } from "@/utils/chat";
import arrow from "./FontSelect/img/arrow.png";
import selected from "./meetingChat/img/selected.png";
import MembersPopover from "./meetingChat";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import { generateMessageId, isLiveMeetingSessionId } from "@jd/jdee.im.sdk/lib/es/utils/utils";
import useShareUserCardInChat from "@/components/Modals/shareUserCardInChat";
import { crossAppSwitch } from "@/utils/tools";
import {
  getClipImgFile,
  isLinuxAndFile
} from "@/components/Work/Comment/InputComment/JEditor/Modules/clipboard";
import { handleDealPasteData } from "@/baseComponents/JEditor/dealPasteData";
import { getFileMd5 } from "@/components/UploadBox/utils";
import { duccConfigI18 } from "@/utils/i18n";
import { PageType } from "@/components/Joyspace/const";
import { buildPagePathKey } from "@/components/Modals/JoyspaceFileSelectorModal/utils";
import NetworkCheck, { UseCheckType } from "@/utils/NetworkCheck";
import i18n from "@/i18n";
import { groupCreates } from "@/components/Joyspace/api";
import QuestionTabs from "@/baseComponents/Chat/QuestionTabs";
import AIBannedInput from "./AIBannedInput";
import { APP_NAME } from "@/config/name";

import { files } from "jszip";
import LLMFiles, { buildMessage } from "@/baseComponents/Chat/LLMFiles";
import sendActive from "@/assets/img/AI/ai-send-active.png";
import sendDisabled from "@/assets/img/AI/ai-send-disabled.png";
import { previewAllowSuffix } from "@/components/Joyspace/util";
import AIImagePanel from "@/baseComponents/Chat/AIImagePanel";
import { CustomMenu } from "@jd/focus-desktop-comps";
// import CustomMenu from "@/baseComponents/CustomMenu";
let count = 0;
const Delta = Quill.import("delta");

const SendMessageIsBanned = "banned_post_tip";
let offCaptureHandle: any = null;
const netServer = NetworkCheck.getInstance({
  url: getNetCheckUrl(),
  checkType: UseCheckType.API
});
interface MessageInputProps {
  Upload?: string;
}

type IMessageInputProps = Readonly<MessageInputProps & WithTranslation>;

interface MessageInputState {
  type: string;
}

function mapStateToProps({ user, chat }: { user: any; chat: ChatState }) {
  return {
    ...user,
    selectedSession: chat.selectedSession,
    groupRobots: chat.groupRobots,
    singleSessionMembers: chat.sessionMembers,
    sessionStatusMap: chat.sessionStatusMap,
    currentEmployee: chat.currentEmployee,
    sessionMessageMap: chat.sessionMessageMap,
    captureType: chat.captureType,
    allSessionList: chat.allSessionList,
    userData: user.userData ? user.userData.user : {},
    quickReplys: chat.quickReplys,
    sendMsgType: chat.sendMsgType,
    isSelectedColor: chat.isSelectedColor,
    privateUser: chat.privateUser,
    questionHistory: chat.questionHistory,
    llmSetting: chat.llmSetting,
    llmFiles: chat.llmInfo?.files,
    llmImages: chat.llmInfo?.images,
    llmFilesReady: chat.llmInfo?.isReady ?? true,
    editorMode: user.editorMode
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    changeViewTab(viewTab: string) {
      dispatch({ type: "calendar/changeViewTab", payload: { viewTab } });
    },
    pushChatMessage(data: { sessionId: string; message: Partial<ChatMessage> }) {
      dispatch({ type: "chat/pushChatMessage", payload: data });
    },
    setSessionStatus(data: { sessionId: string; sessionStatusInfo: SessionStatusInfo }) {
      dispatch({ type: "chat/setSessionStatus", payload: data });
    },
    setMessageInputFocus(data: boolean) {
      dispatch({ type: "chat/setMessageInputFocus", payload: data });
    },
    setPrivateUser(data: any) {
      dispatch({ type: "chat/setPrivateUser", payload: data });
    },
    async setMsgtureType(data: { sendMsgType: string }) {
      await dispatch({ type: "chat/setMsgtureType", payload: data });
    },
    dealStopQuestions(data: any) {
      dispatch({ type: "chat/dealStopQuestions", payload: data });
    },
    setTablePasteFormat: (data: any) => {
      dispatch({ type: "user/setTablePasteFormat", payload: data });
    },
    updateLLMInfo(data: any) {
      dispatch({ type: "chat/updateLLMInfo", payload: data });
    },
    setEditorMode: (data: any) => {
      dispatch({ type: "user/setEditorMode", payload: data });
    }
  };
}

export const InitImgState: {
  base64: any;
  title: string;
  width: number;
  height: number;
  size: number;
} = {
  title: "",
  base64: "",
  width: 0,
  height: 0,
  size: 0
};

interface IState {
  imgState: typeof InitImgState;
  imgUploadModalVisible: boolean;
  file: any;
  fileList: any[];

  replyVisible: boolean;
  replyText: string;
  replyUser: Partial<Employee> | null;
  replyMessage: Partial<ChatMessage>;

  quickReplyVisible: boolean; // 常用语
  emojiVisible: boolean;
  fontVisible: boolean;
  listVisible: boolean;
  permissionVisible: boolean;
}

const initialState: IState = {
  imgState: InitImgState,
  imgUploadModalVisible: false,
  file: null,
  fileList: [],

  replyVisible: false,
  replyText: "",
  replyUser: null,
  replyMessage: {},

  quickReplyVisible: false,
  emojiVisible: false,
  fontVisible: false,
  listVisible: false,
  permissionVisible: false
};

function reducer(state: IState, action: any) {
  const { payload } = action;

  switch (action.type) {
    case "openUploadImgModal":
      // eslint-disable-next-line no-case-declarations
      const { imgState, file, fileList } = payload;
      return { ...state, imgUploadModalVisible: true, imgState, file, fileList };
    case "closeUploadImgModal":
      return { ...state, imgUploadModalVisible: false };
    case "clearImageState":
      return { ...state, imgState: {}, file: null, fileList: [] };
    case "closeReply":
      return {
        ...state,
        replyText: "",
        replyVisible: false,
        replyUser: null,
        replyMessage: {}
      };
    case "showReply":
      return {
        ...state,
        replyVisible: true,
        replyText: payload.replyText,
        replyUser: payload.replyUser,
        replyMessage: payload.replyMessage
      };
    case "changeQuickReplyVisible":
      if (payload.quickReplyVisible) {
        analysisLog("Xtbg_Msg_Info_MsgDialog", "AddTerm");
        return {
          ...state,
          quickReplyVisible: true,
          emojiVisible: false,
          fontVisible: false
        };
      }
      return {
        ...state,
        quickReplyVisible: false
      };
    case "changeEmojiVisible":
      if (payload.visible) {
        analysisLog(
          "Xtbg_Msg_Info_MsgDialog",
          payload.quillModal ? "RichTextMessage_Emoji" : "AddEmo"
        );
        return {
          ...state,
          quickReplyVisible: false,
          fontVisible: false,
          emojiVisible: true
        };
      }
      return {
        ...state,
        emojiVisible: false
      };
    case "changeFontVisible":
      if (payload.visible) {
        return {
          ...state,
          quickReplyVisible: false,
          emojiVisible: false,
          fontVisible: true
        };
      }
      return {
        ...state,
        fontVisible: false
      };
    case "changePermissionVisible":
      if (payload.visible) {
        return {
          ...state,
          quickReplyVisible: false,
          emojiVisible: false,
          permissionVisible: true
        };
      }
      return {
        ...state,
        permissionVisible: false
      };
    case "changelistVisible":
      if (payload.visible) {
        return {
          ...state,
          quickReplyVisible: false,
          emojiVisible: false,
          listVisible: true
        };
      }
      return {
        ...state,
        listVisible: false
      };
    case "handleAtClick":
      return {
        ...state,
        quickReplyVisible: false,
        emojiVisible: false,
        fontVisible: false
      };
    case "handlemeetingClick":
      return {
        ...state,
        quickReplyVisible: false,
        emojiVisible: false,
        fontVisible: false
      };
    case "handleImgClick":
      return {
        ...state,
        quickReplyVisible: false,
        emojiVisible: false,
        fontVisible: false
      };
    default:
      throw new Error();
  }
}

/**
 * 判断最后一个
 * @param {*} delta
 */
function isEndwithEnter(delta: any) {
  if (delta.ops.length < 1) {
    return false;
  }
  let length = delta.ops.length;
  const op = delta.ops[length - 1];
  if (typeof op.insert === "string" && op.insert.endsWith("\n")) {
    return true;
  }
  return false;
}

function MessageInput({
  currentEmployee,
  selectedSession,
  groupRobots,
  singleSessionMembers,
  uploadFile,
  uploadImg,
  uploadMultiImg,
  pushChatMessage,
  sendJoyspaceMessage,
  setSessionStatus,
  setMessageInputFocus,
  setMsgtureType,
  sessionStatusMap,
  sessionMessageMap,
  captureType,
  allSessionList,
  userData,
  quickReplys,
  sendMsgType,
  dealStopQuestions,
  isSelectedColor,
  privateUser,
  setPrivateUser,
  questionHistory,
  setTablePasteFormat,
  llmSetting,
  llmFiles,
  llmImages,
  llmFilesReady,
  updateLLMInfo,
  editorMode,
  setEditorMode
}: {
  currentEmployee: Employee;
  selectedSession: Session;
  groupRobots: Partial<any>[];
  singleSessionMembers: Partial<Employee>[];
  sessionStatusMap: any;
  sessionMessageMap: any;
  uploadFile: (file: any, multiple?: any, path?: any) => void;
  uploadImg: (imgState: typeof InitImgState, file: any, isOrigin?: boolean) => void;
  uploadMultiImg: (uploadList: any, isOrigin?: boolean) => void;
  pushChatMessage: (data: { sessionId: string; message: Partial<ChatMessage> }) => void;
  sendJoyspaceMessage: (data: any[]) => void;
  setSessionStatus: (data: { sessionId: string; sessionStatusInfo: SessionStatusInfo }) => void;
  setMessageInputFocus: (data: boolean) => void;
  setMsgtureType: Function;
  captureType: string;
  allSessionList: Session[];
  userData: UserModel;
  quickReplys: QuickReply[];
  sendMsgType: string;
  dealStopQuestions: Function;
  isSelectedColor: string;
  privateUser: any;
  setPrivateUser: any;
  questionHistory: any[];
  setTablePasteFormat: Function;
  llmSetting: any;
  llmFiles: any[];
  llmImages: any[];
  llmFilesReady: boolean;
  updateLLMInfo: Function;
  editorMode: string;
  setEditorMode: Function;
}) {
  const {
    groupRosters,
    groupRosterIdentity,
    closeSetting,
    httpMatchUrls,
    blackUrls
  } = React.useContext(Context);
  const { appRuntimeEnv, localConfigData, focusSDK } = useContext<GlobalContextConfig>(
    GlobalContext
  );
  const { fileService, im } = appRuntimeEnv;
  const { appKey } = fileService;
  const llmFilesRef = useRef(llmFiles);
  const llmImagesRef = useRef(llmImages);
  const enterAllowRef = useRef(llmFilesReady);

  const shareUserCard = useShareUserCardInChat({
    currentEmployee,
    selectedSession,
    userData
  });

  const meetingRoster = useMemo(() => {
    let tempRosters = Object.values((selectedSession.info as any).rosters || []);
    const rosters: any[] = tempRosters.map((item: any) => {
      const user = { ...item?.info, identity: item.identity } as any;
      return user;
    });
    return rosters || [];
  }, [selectedSession.info]);

  const isMaster = useMemo(() => {
    return isGroupAdmin(groupRosterIdentity) || isGroupOwner(groupRosterIdentity);
  }, [groupRosterIdentity]);

  const isOutApp = selectedSession.isGroup
    ? isCrossPlatformGroupSession(selectedSession)
    : isOuterContacts(selectedSession, currentEmployee);

  const sessionMembers: Partial<Employee>[] = useMemo(
    function () {
      if ([SessionType.SINGLE, SessionType.SECRET_SINGLE].includes(selectedSession.sessionType)) {
        const tempSingleSessionMembers = singleSessionMembers.map((item: any) => {
          if (item.userId === "all") {
            item.role = "all";
          } else {
            item.role = "user";
          }
          return item;
        });
        return (tempSingleSessionMembers || []) as Partial<Employee>[];
      } else if (selectedSession.sessionType === SessionType.GROUP) {
        let tempRosters = Object.values((selectedSession.info as any).rosters || []);
        if (tempRosters && tempRosters.length > 0) {
          tempRosters = mapRosters(tempRosters);
        } else {
          tempRosters = groupRosters;
        }
        const rosters: any[] = tempRosters
          .map((item: any) => {
            const user = { ...item?.info, alias: item.alias, role: "user" } as any;
            return user;
          })
          .filter((item) => item?.userId && item?.app && item?.teamId && item?.name);
        const all = {
          app: currentEmployee.app || "",
          name: "全体成员",
          userId: "all",
          teamId: currentEmployee.teamId,
          role: "all"
        };
        const result = getOrgList(tempRosters);
        let users =
          result.length > 1
            ? [all, ...result, ...rosters, ...groupRobots]
            : [all, ...rosters, ...groupRobots];
        users = compareLetter(users, "name");
        return users;
      } else if (selectedSession.sessionType === SessionType.MEETING_GROUP) {
        const rosters: any[] = [...meetingRoster];
        const all = {
          name: "所有人",
          userId: "all"
        };
        // 在这里根据权限过滤一下人员列表 0 保留所有人 1 仅保留主持人(主持人或联席主持人除外)
        const curPer = selectedSession?.settings?.permissionEnum;
        if (curPer === 1 && !isMaster) {
          let publicList: any[] = rosters.filter((item: any) => {
            return isGroupOwner(item.identity) || isGroupAdmin(item.identity);
          });
          return [all, ...publicList];
        } else if (curPer === 2 && !isMaster) {
          let newRosters: any[] = rosters.filter((item: any) => {
            return isGroupOwner(item.identity);
          });
          return newRosters;
        } else {
          return [all, ...rosters];
        }
      }
      return [];
    },
    [
      selectedSession.sessionType,
      selectedSession.info,
      selectedSession.settings.permissionEnum,
      singleSessionMembers,
      currentEmployee.app,
      currentEmployee.teamId,
      groupRosters,
      groupRobots,
      meetingRoster,
      isMaster
    ]
  );

  const meetingRosterLen = useMemo(() => {
    const users = (sessionMembers || []).filter(
      (i: any) =>
        i.userId !== "all" &&
        !(isEqualEmployee(currentEmployee, i) && i.clientType === getClientType())
    );
    return users.length;
  }, [sessionMembers, currentEmployee]);

  const isShowmodal = useMemo(() => {
    return (meetingRoster?.length || 0) > 1;
  }, [meetingRoster.length]);

  useEffect(() => {
    const curPer = selectedSession?.settings?.permissionEnum;
    if ((curPer === 1 && !isMaster) || (isMaster && curPer === 2)) {
      setPrivateUser({ userName: "所有人", pin: "all" });
    } else if (curPer === 2 && !isMaster) {
      const admin = meetingRoster.find((item) => isGroupOwner(item.identity));
      if (!admin) {
        return;
      }
      const moderatorInfo = {
        app: admin?.app || "",
        teamId: admin?.teamId || "",
        userName: admin.name || "",
        pin: admin?.userId || "",
        unitName: admin?.desc || "",
        clientType: admin?.clientType
      };
      setPrivateUser(moderatorInfo);
    }
  }, [isMaster, meetingRoster, selectedSession.settings.permissionEnum, setPrivateUser]);

  const divEl = useRef(null);
  const inputRef = useRef<JEditor | null>(null);
  const [inputWidth, setInputWidth] = useState(100);
  const [expand, setExpand] = useState(false);
  const [visible, setVisible] = useState(false);
  const [pasteVisible, setpasteVisible] = useState(false);
  const [copyVisible, setcopyVisible] = useState(false);
  const preSelectedId = usePrevious(selectedSession.id);
  const [state, dispatch] = useReducer(reducer, initialState);
  const draftRef = useRef<any>(null);
  const [t] = useTranslation("chat");
  const [t1] = useTranslation("common");
  const countRef = useRef(50);
  // cxz修改
  const [isenter, setIsenter] = useState("");
  const [isctrl, setIsctrl] = useState("");
  const [keyNum, setKeyNum] = useState("");
  const [copyTexts, setcopyText] = useState(false);
  const permissionText = [
    t("meeting_chat_setting.all"),
    t("meeting_chat_setting.open"),
    t("meeting_chat_setting.private"),
    t("meeting_chat_setting.banned")
  ];
  const [saveRecordtip, setsaveRecordtip] = useState(false);

  // 是否复制了表格，表格可选粘贴为图片
  const [pasteTableImg, setPasteTableImg] = useState(false);
  const [tempTableImgFiles, setTempTableImgFiles] = useState([]);
  const [pastData, setPastData] = useState({});
  const [quillModal, setQuillModal] = useState(false);
  const maskHeight = useRef("0px");

  // lyj 是否发送多张图片
  const [isMulti, setMulti] = useState(false);
  // 当前question tab
  const questionTab = useRef<any>(null);

  const isCompositionModeRef = useRef(false);
  // message
  const sessionMessages = sessionMessageMap[selectedSession.sessionId];
  const { lastMessage } = useContext(Context);
  const [hasContent, setHasContent] = useState(false);
  const placeholderText = useMemo(() => {
    if (isAIChatSession(selectedSession)) {
      return "有问题尽管问我";
    } else {
      return "请输入消息";
    }
  }, [selectedSession]);

  const handleResize = useCallback(() => {
    if (
      ![
        SessionType.SINGLE,
        SessionType.SECRET_SINGLE,
        SessionType.GROUP,
        SessionType.MEETING_GROUP,
        SessionType.LIVE_MEETING_GROUP
      ].includes(selectedSession.sessionType)
    ) {
      return;
    }
    const cu: any = divEl.current;
    if (cu) {
      const width = cu.clientWidth;

      let rightWidth = 14;

      const right = cu.querySelector(".input-control-container-right");
      if (right) {
        rightWidth += right.clientWidth;
      }

      const inputWidth = width - rightWidth;
      setInputWidth(inputWidth);
      const div = cu.querySelector(".ql-editor");
      if (!div) {
        return;
      }
      const editWidth = div.scrollWidth;
      if (editWidth > inputWidth) {
        setExpand(true);
      } else {
        setExpand(false);
      }
    }
  }, [selectedSession]);

  // 在输入时保存一下草稿信息
  function saveDraft(session: any) {
    const jeditor: any = inputRef.current;
    if (!jeditor) {
      return;
    }
    const { text, userIds, delta } = jeditor.getTextMessage();
    if (text === "") {
      setcopyText(false);
    } else {
      setcopyText(true);
    }
    // console.log('保存草稿', text);
    const uids: any[] = [];
    userIds.forEach((u: string) => {
      const temp: any = sessionMembers.find((i: any) => {
        return extraConvertEmployeeToString(i) === u;
      });
      // console.log('遍历结果', temp);
      if (temp) {
        let uid: any;
        if (temp.role === "unit") {
          uid = {
            nickname: temp.name,
            unitId: temp.unitDeptId
          };
        } else if (temp.role === "dept") {
          uid = {
            nickname: temp.name,
            deptId: temp.deptId
          };
        } else if (temp.role === "title") {
          uid = {
            nickname: temp.name,
            titleId: temp.titleId
          };
        } else {
          uid = {
            app: temp.app || "",
            teamId: temp.teamId || "",
            nickname: temp.name,
            pin: temp.userId || "",
            alias: isShowAlias(selectedSession) ? temp.alias || "" : "",
            remark: temp.remark
          };
        }
        uids.push(uid);
      }
    });
    let info = {
      atUsers: uids,
      content: text,
      delta
    };
    if (isShowAlias(selectedSession) && info.atUsers?.length > 0) {
      info = handleExpandContent(info, selectedSession);
    }
    draftRef.current = {
      sessionId: session.id || "",
      sessionStatusInfo: {
        status: MessageStatus.EDITING,
        // timestamp: Date.now(),
        timestamp: new Date().getTime(),
        info
      }
    };
  }

  const onMainWinHidden = useCallback(() => {
    const jeditor: any = inputRef.current;
    if (!jeditor) {
      return;
    }
    const { text } = jeditor.getTextMessage();
    if (text?.trim()) {
      saveDraft(selectedSession);
    }
    if (selectedSession?.sessionId && draftRef.current) {
      setSessionStatus(draftRef.current);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedSession]);

  /**
   * 切换聊天窗口时清空输入框
   */
  useEffect(() => {
    let weizhi: any = document.getElementById("input-control-container");
    let inputLine: any = document.getElementById("input-line");
    if (!weizhi || !inputLine) {
      return;
    }
    if (weizhi.style?.height === "500px" && preSelectedId !== selectedSession.id) {
      setQuillModal(false);
      weizhi.style.height = "160px";
      inputLine.style.cursor = "n-resize";
    }
    const jeditor: any = inputRef.current;
    if (!jeditor) {
      return;
    }
    if (preSelectedId !== selectedSession.id) {
      if (draftRef.current) {
        setSessionStatus(draftRef.current);
        draftRef.current = null;
      }
      jeditor.setQuillModal(false);
      jeditor.clearMessage();
      // 从草稿中提取信息
      const { info } = sessionStatusMap[selectedSession.id] || {};
      if (info) {
        // jeditor.insertText(info.content);
        const quill = jeditor.getQuill();
        if (quill) {
          quill.setContents(info.delta);
          setTimeout(() => {
            const length = quill.getLength();
            quill.setSelection(length);
          });
        }
      }
      // jeditor.changePlaceholder(t('send_to_sb').replace('%s', selectedSession.info.name));
      dispatch({ type: "closeReply" });
      jeditor.focus();
      if (detectOS() === "Win") {
        setMessageInputFocus(true);
      }
      jeditor.changePlaceholder(placeholderText);
    }
  }, [
    selectedSession.id,
    selectedSession.info.name,
    setSessionStatus,
    setMessageInputFocus,
    t,
    preSelectedId,
    sessionStatusMap,
    placeholderText
  ]);

  /**
   * 消息输入框是否焦点
   */
  const onEditorFocus = useCallback(
    (status: boolean) => {
      if (detectOS() === "Win") {
        setMessageInputFocus(status);
      }
    },
    [setMessageInputFocus]
  );

  useEffect(() => {
    const jeditor: any = inputRef.current;
    if (!jeditor || !jeditor.events) {
      return;
    }
    jeditor.events.on("editor-on-focus", onEditorFocus);
    return () => {
      jeditor.events.off("editor-on-focus", onEditorFocus);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    return () => {
      onMainWinHidden();
    };
  }, [onMainWinHidden]);

  const [inputDisable, setInputDisable] = useState(false);

  const isBanned = useMemo(() => {
    return isGroupOrdinary(groupRosterIdentity) && isBannedPostGroupSession(selectedSession);
  }, [groupRosterIdentity, selectedSession]);
  // 群解散
  const sessionFlag = useMemo(() => {
    const { info } = sessionStatusMap[selectedSession.id] || {};
    if (!info) {
      return selectedSession.isGroup && (selectedSession.info as any).status === 0;
    }
    return selectedSession.isGroup && (selectedSession.info as any).status === 0 && !info?.content;
  }, [selectedSession.id, selectedSession.info, selectedSession.isGroup, sessionStatusMap]);

  const sessionFlags = useMemo(() => {
    return selectedSession.isGroup && (selectedSession.info as any).status === 0;
  }, [selectedSession]);

  // 群禁言时处理一下交互
  useEffect(() => {
    if (isBanned) {
      const jeditor: any = inputRef.current;
      if (!jeditor) {
        // eslint-disable-next-line no-console
        console.log("can not find jeditor");
        return;
      }
      const { text } = jeditor.getTextMessage();
      if (text) {
        return;
      }
      setInputDisable(true);
      setTimeout(() => {
        jeditor.changePlaceholder(t("Group manager has been banned"));
      });
    } else {
      setInputDisable(false);
    }
  }, [isBanned, t]);

  const isMeetingBanned = useMemo(() => {
    return (
      (selectedSession.sessionType === SessionType.MEETING_GROUP ||
        selectedSession.sessionType === SessionType.LIVE_MEETING_GROUP) &&
      selectedSession?.settings?.permissionEnum === 3 &&
      !isGroupAdmin(groupRosterIdentity) &&
      !isGroupOwner(groupRosterIdentity)
    );
  }, [groupRosterIdentity, selectedSession.sessionType, selectedSession.settings.permissionEnum]);
  /**
   * 设置回复的数据
   * @param props
   */
  let qlContainer: any = document.querySelector(".ql-container");
  // eslint-disable-next-line react-hooks/exhaustive-deps
  function handleReply(props: any) {
    if (isBanned) {
      toast.warn("群已禁言，无法引用");
      return;
    }
    if (sessionFlags) {
      toast.warn("群已解散，无法引用");
      return;
    }
    let weizhi: any = document.getElementById("input-control-container"); // 输入框
    const { replyText, replyUser, replyMessage } = props;
    dispatch({ type: "showReply", payload: { replyText, replyUser, replyMessage } });
    const jeditor: any = inputRef.current;
    if (replyText && weizhi?.style.height <= 160 + "px") {
      qlContainer.style.maxHeight = 36 + "px";
    }
    if (replyText && weizhi?.style.height >= 266 + "px") {
      qlContainer.style.maxHeight = 138 + "px";
    }
    if (!jeditor) {
      return;
    }
    jeditor.focus();
  }

  // 撤回编辑
  // eslint-disable-next-line react-hooks/exhaustive-deps
  // eslint-disable-next-line complexity
  function SetMessageFromReEdit(props: any) {
    const { message } = props;
    let { atUsers, content } = message;
    const jeditor: any = inputRef.current;
    if (!jeditor) {
      return;
    }
    const quill = jeditor.getQuill();
    let range = { index: 0, length: 0 };
    let { delta } = jeditor.getTextMessage();
    if (isEndwithEnter(delta)) {
      const length = delta.length();
      delta = delta.compose(new Delta().retain(length - 1).delete(1));
    }
    // 富文本消息
    if (message?.quillJson?.length) {
      const msgDelta =
        typeof message.quillJson === "string" ? JSON.parse(message.quillJson) : message.quillJson;
      if (quill) {
        quill.setContents({ ops: msgDelta });
        setTimeout(() => {
          const length = quill.getLength();
          quill.setSelection(length);
        });
      }
      return;
    }
    let result = content;
    if (atUsers && atUsers?.length > 0) {
      let tempIndex = 0;
      for (const u of atUsers) {
        const role =
          u.hasOwnProperty("pin") && u.pin === "all"
            ? "all"
            : u.hasOwnProperty("unitId")
            ? "unit"
            : u.hasOwnProperty("deptId")
            ? "dept"
            : u.hasOwnProperty("titleId")
            ? "title"
            : "user";
        // const user_alias = getUserAlias({ ...u, userId: u.pin }, selectedSession);
        const atStr = `@${u.nickname}`;
        tempIndex = result.indexOf(atStr);
        if (tempIndex >= 0) {
          delta = delta.insert(result.substring(0, tempIndex)).insert({
            "mention-link": {
              id: `${u?.pin || u?.unitId || u?.deptId || u?.titleId || ""}:${
                u?.app || currentEmployee.app || ""
              }:${u?.teamId || currentEmployee.teamId || ""}:${role}`,
              // id: `${u?.pin}:${u?.app}:${u?.teamId}`,
              type: "user",
              name: u.nickname,
              alias: u.alias,
              remark: u.remark
            }
          });
          result = result.substr(tempIndex + atStr.length);
        }
      }
      delta = delta.insert(result);
    } else {
      content = content.replace(/</g, "&lt;").replace(/>/g, "&gt;");
      const patt = /\[.*?\]/g;
      const re = content.match(patt);
      let result = content;
      if (re && re.length > 0) {
        const reSet = new Set([...re]);
        reSet.forEach((r: string) => {
          if (!r) {
            return;
          }
          if (!stickers_sets[r]) {
            return;
          }
          let tmpIndex = r.indexOf("]");
          let tmpStr = r.substring(1, tmpIndex);
          let regexp = new RegExp(`\\[${tmpStr}\\]`, "g");
          result = result.replace(
            regexp,
            `<span class="e-emoji" contenteditable="false" data-value="${r}">&#65279;<span contenteditable="false">${r}</span>&#65279;</span>`
          );
        });
      }
      const pattern1 = /[\uD800-\uDBFF][\uDC00-\uDFFF]/;
      const specialEmojiRegex = /\p{Emoji_Modifier_Base}\p{Emoji_Modifier}?|\p{Emoji_Presentation}|\p{Emoji}\uFE0F/gu;
      let rtnResult = "";
      for (const temp of result) {
        if (pattern1.test(temp) && stickers_sets[temp]) {
          rtnResult += `<span class="e-emoji" contenteditable="false" data-value="${temp}">&#65279;<span contenteditable="false">${temp}</span>&#65279;</span>`;
        } else {
          if (
            (specialEmojiRegex.test(temp) && stickers_sets[temp]) ||
            specialEmojiRegex.test(temp)
          ) {
            // console.log('2', specialEmojiRegex.test(temp));
            rtnResult += `<span class="e-emoji" contenteditable="false" data-value="${temp}">&#65279;<span contenteditable="false">${temp}</span>&#65279;</span>`;
          } else {
            rtnResult += temp;
          }
        }
      }
      const contents = rtnResult.replace(/\n/g, "<br/>");
      const p = `<p>${contents}</p>`;
      delta = quill.clipboard.convert(p).delete(range.length);
      let NewResult = new Delta().retain(range.index);
      delta.forEach((op: any) => {
        if (op.insert && (typeof op.insert === "string" || op.insert["custom-emoji"])) {
          NewResult.ops.push({ insert: op.insert });
        }
      });
      NewResult = NewResult.delete(range.length);
      quill.updateContents(result, "user");
    }
    // quill.updateContents(result, 'user');
    // // range.length contributes to delta.length()
    // quill.setSelection(result.length() - range.length, 'silent');
    if (quill) {
      quill.setContents(delta);
      setTimeout(() => {
        const length = quill.getLength();
        quill.setSelection(length);
      });
    }
  }

  // eslint-disable-next-line max-params
  function getFileFrom(url: any, imageName: any, type: any) {
    return new Promise((resolve, reject) => {
      let blob: any = null;
      const xhr = new XMLHttpRequest();
      xhr.open("GET", url);
      xhr.setRequestHeader("Accept", type);
      xhr.responseType = "blob";
      xhr.onload = () => {
        blob = xhr.response;
        let imgFile = new window.File([blob], decodeURIComponent(imageName), {
          type: blob?.type || type
        });
        if (imgFile.type !== "false") {
          resolve(imgFile);
        } else {
          resolve({ data: "" });
        }
      };
      xhr.onerror = (e) => {
        console.log("错误", e);
        xhr.abort();
        resolve({ data: null, imageName });
      };
      xhr.onprogress = (env) => {
        if (env.total >= 500 * 1024 * 1024) {
          toast.error({
            content: "目前仅支持复制粘贴大小为500M以下的文件",
            key: 2
          });
          resolve({ data: null, imageName });
          xhr.abort();
          return;
        }
        let bolb = new window.File([decodeURIComponent(url)], decodeURIComponent(imageName), {
          type: blob?.type || type
        });
        const loaded = (env.loaded / env.total) * 100;
        const newImgFile = [
          {
            ...bolb,
            name: bolb.name,
            type: bolb.type,
            loaded: loaded
          }
        ];
        // if (newImgFile && !newImgFile[0].type.match(/^image\/(gif|jpe?g|png|webp|bmp)/i)) {
        //   const f = newImgFile.findIndex((i) => i.type !== "false");
        //   if (f !== -1) {
        //     uploadFile(newImgFile, "single", decodeURIComponent(url).replace("file://", ""));
        //   }
        // }
      };
      xhr.send();
    });
  }
  const getUsefilePath = (file: []) => {
    let Path: any = null;
    let newFiles: any = [];
    if (file?.length === 0) {
      return;
    }
    let onFile: any = file;
    bus.emit("work:comment-inputcomment-jeditor-modules-clipboard", file);
    file.map(async ({ data, filePath, fileName }) => {
      Path = decodeURIComponent(filePath);
      getFileFrom(filePath, fileName, lookup(fileName) as any)
        .then((res: any) => {
          if (res.data === null) {
            onFile.splice(0, 1);
            console.log("哈哈哈哈哈", decodeURIComponent(lookup(fileName) as any));
            if (decodeURIComponent(lookup(fileName) as any) === "false") {
              toast.warning({
                content: "暂不支持发送文件夹，您可以将文件夹压缩后发送",
                key: 1
              });
            }
          } else {
            newFiles.push(res);
          }
          if (newFiles.length === onFile.length) {
            const allImage =
              newFiles &&
              newFiles.filter((i: any) => !i.type.match(/^image\/(gif|jpe?g|png|webp|bmp)/i))
                .length === 0;
            if (newFiles && !allImage) {
              uploadFile(newFiles, "multi");
              return;
            } else {
              handleUploadImgs(newFiles);
            }
          }
          // else if (newFiles.length > 1) {
          //     uploadFile(newFiles, 'single');
          // } else {
          //     uploadFile(newFiles, 'single');
          // }
        })
        .catch((err) => {
          console.log(err);
        });
      return newFiles;
    });
  };

  const dealPasteData = async () => {
    console.log("paste-dealData", pastData);
    let { range, text, html, files, doc, _this } = pastData as any;
    if (!html && !text && (!files || files?.length === 0)) {
      toast.error("受系统剪切板大小限制，不支持该次粘贴操作");
      closeContextMenu();
      return;
    }
    // isFocusEnv() && FocusSDK.clipboadMultiple();
    if (!html && !text && files.length > 0) {
      handleUploadImgs(files);
      return;
    }
    const container = doc.body;
    if (container && files.length > 0) {
      if (container.childElementCount === 1) {
        if (container.firstElementChild?.tagName.toLocaleUpperCase() === "IMG") {
          handleUploadImgs(files);
          return;
        }
      }
    }
    if (text) {
      let type: any = lookup(text) || "";
      if (type.match(/^image\/(gif|jpe?g|a?png)/i)) {
        let file = await getClipImgFile(type);
        // console.log('file---', file);
        if (file) {
          return handleUploadImgs([file], range);
        }
      }
      // 国产操作系统且是文件但获取不到剪贴板文件
      if (isLinuxAndFile(text)) {
        text = "";
        AntMessage.warn("当前浏览器不支持粘贴文件，请拖拽文件至当前窗口");
        return;
      }
    }
    handleDealPasteData(pastData);
  };

  const hanldeSetPaste = (files: any) => {
    setTempTableImgFiles(files);
    setPasteTableImg(true);
  };

  const handleClickPasteData = (data: any) => {
    setPastData(data);
  };

  useEffect(() => {
    bus.on("available:table-to-img", hanldeSetPaste);
    bus.on("click:paste", handleClickPasteData);
    bus.on("input:setContent", repaceText);
    FocusSDK.on("chat:evt:input-setContent", repaceText);
    FocusSDK.on("usefilePath", getUsefilePath);
    return () => {
      bus.off("available:table-to-img", hanldeSetPaste);
      bus.off("click:paste", handleClickPasteData);
      bus.off("input:setContent", repaceText);
      FocusSDK.off("chat:evt:input-setContent", repaceText);
      FocusSDK.off("usefilePath", getUsefilePath);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSendMsgEvent = useCallback(
    (str: string) => {
      if (isAINoticeSession(selectedSession)) {
        return;
      }
      const jeditor = inputRef.current;
      if (!jeditor) {
        return;
      }
      repaceText(str);
      sendMessage();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [selectedSession]
  );

  useEffect(() => {
    FocusSDK.on("chat:evt:input-sendMsg", handleSendMsgEvent);
    return () => {
      FocusSDK.off("chat:evt:input-sendMsg", handleSendMsgEvent);
    };
  }, [selectedSession, handleSendMsgEvent]);

  function doTableImgPaste(e: any) {
    const files = tempTableImgFiles;
    handleUploadImgs(files, (pastData as any).range, "table");
    // TODO: 这里要写入配置到本地config文件，确保下次快捷键粘贴表格信息时使用
    setTablePasteFormat("image");
    setPasteTableImg(false);
    setTempTableImgFiles([]);
    setPastData({});
  }

  function doPaste(e: any) {
    e.stopPropagation();
    const jeditor: any = inputRef.current;
    if (!jeditor) {
      return;
    }
    document.addEventListener("paste", onPaste);

    async function onPaste(e: any) {
      // 禁言的会话
      if (isBannedPostGroupSession(selectedSession)) {
        return false;
      }
      document.removeEventListener("paste", onPaste);
    }
    // jeditor.focus();
    dealPasteData();
    if (pasteTableImg) {
      setTablePasteFormat("text");
      setPasteTableImg(false);
      setTempTableImgFiles([]);
      setPastData({});
    }
    setpasteVisible(false);
    setcopyVisible(false);
  }

  function doCopy(e: any) {
    e.stopPropagation();
    const jeditor: any = inputRef.current;
    if (!jeditor) {
      return;
    }
    let { text, delta } = jeditor.getTextMessage();
    let userSelection: any;
    let str = text;
    if (typeof window.getSelection === "function") {
      const selectionObj = window.getSelection();
      const rangeObj = selectionObj?.getRangeAt(0);
      userSelection = rangeObj?.cloneContents();
      if (rangeObj?.cloneContents().querySelector("p")) {
        str = text;
        // return;
      } else {
        const Selection = userSelection?.querySelectorAll("img");
        Selection?.forEach((item: any) => {
          let tempDiv = document.createElement("span");
          tempDiv.innerText = item.getAttribute("data-value") || "";
          userSelection?.replaceChild(tempDiv, item);
        });
      }
      // userSelection = window.getSelection();
    }
    if (userSelection?.textContent) {
      str = userSelection?.textContent;
    }
    // if (str && CopyClipboard(str) && e.keyCode === 88) {
    //     insertText(str.splice(0, str.length));
    //     return;
    // }
    if ((str || "").length > (text || "").length) {
      str = text;
    }
    if (
      str &&
      CopyClipboard(str, {
        onCopy: (clipboard: any) => {
          clipboard.setData("text/plain", str);
          clipboard.setData("text/quill", JSON.stringify(delta.ops));
        }
      })
    ) {
      toast.success(t("copy-succeeded"));
    } else {
      toast.error(t("copy-failed"));
    }
    jeditor.focus();
    setcopyVisible(false);
    setpasteVisible(false);
  }
  function focus() {
    const jeditor: any = inputRef.current;
    state.replyVisible = false;
    qlContainer.style.maxHeight = null;
    if (!jeditor) {
      return;
    }
    jeditor.focus();
  }

  function setContent(delta: any) {
    const jeditor: any = inputRef.current;
    if (!jeditor) {
      return;
    }
    const quill = jeditor.getQuill();
    if (quill) {
      quill.setContents(delta);
      setTimeout(() => {
        const length = quill.getLength();
        quill.setSelection(length);
      });
    }
  }

  /**
   * 初始化数据及监听
   */
  useEffect(() => {
    const stt = setTimeout(() => {
      clearTimeout(stt);
      handleResize();
    }, 200);

    window.addEventListener("resize", handleResize);

    if (ChatEvent) {
      // 处理右侧展开
      ChatEvent.on("rightSide-change", handleResize);
      // 处理reply
      ChatEvent.on("chat-reply", handleReply);
      ChatEvent.on("close-mention", closeMention);
      ChatEvent.on("reedit-message", SetMessageFromReEdit);
      ChatEvent.on("chat-input-content", setContent);
    }

    return () => {
      window.removeEventListener("resize", handleResize);
      if (ChatEvent) {
        ChatEvent.removeListener("rightSide-change", handleResize);
        ChatEvent.removeListener("chat-reply", handleReply);
        ChatEvent.removeListener("close-mention", closeMention);
        ChatEvent.removeListener("reedit-message", SetMessageFromReEdit);
        ChatEvent.removeListener("chat-input-content", setContent);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [handleReply, handleResize]);

  const handleSearch = useCallback(
    (input: string) => {
      if (!input) {
        console.log("sessionMembers:", sessionMembers);
        return sessionMembers;
      }
      const temp = sessionMembers.filter((item: any) => item.role !== "all");
      console.log("temp:", temp);
      return temp.filter((s: any) => {
        const condition =
          PinyinMatch.match(s.name || "", input) ||
          PinyinMatch.match(s?.unitName || "", input) ||
          PinyinMatch.match(s?.deptName || "", input) ||
          PinyinMatch.match(s?.titleName || "", input);
        console.log("name:", s.name);
        console.log("condition:", condition);
        if (s?.remark) {
          return condition || PinyinMatch.match(s?.remark || "", input);
        } else if (isShowAlias(selectedSession)) {
          return condition || PinyinMatch.match(s?.alias || "", input);
        } else {
          return condition;
        }
      }); // [1, 3])
    },
    [sessionMembers, selectedSession]
  );

  function closeMention() {
    const jeditor: any = inputRef.current;
    if (!jeditor) {
      return;
    }
    jeditor.events.emit("close-mention");
  }

  /**
   * 内容变更事件
   * @param delta
   */
  function contentChange(delta: any, oldDelta: any, source: Sources) {
    const jeditor: any = inputRef.current;
    if (!jeditor) {
      return;
    }
    const length = inputRef.current?.getQuill()?.getLength() || 0;
    setHasContent(length - 1 > 0);
    handleInputStyleChange();
    saveDraft(selectedSession);
    if (visible) {
      setVisible(false);
    }
  }

  useEffect(() => {
    setMsgtureType({ sendMsgType: localConfigData.sendMsgType || "1" });
    if (localConfigData.sendMsgType === "1") {
      setIsenter("Enter");
      setIsctrl("Ctrl + Enter");
    } else if (localConfigData.sendMsgType === "2") {
      setIsenter("Ctrl + Enter");
      setIsctrl("Enter");
    }
  }, [setMsgtureType, localConfigData.sendMsgType]);

  const isMac = useMemo(() => {
    let platform = FocusSDK.getDeviceInfo().platform;
    if (platform === "web") {
      let uaParser = new UAParser();
      let os = uaParser.getOS();
      return (os?.name as string).indexOf("Mac") > -1 || (os?.name as string).indexOf("iOS") > -1;
    }
    return platform === "darwin";
  }, []);

  const captureTips = useMemo(() => {
    const { captureHotkey, captureHotkey2 } = localConfigData;
    if (!captureHotkey && !captureHotkey2) {
      return "截屏";
    }
    if (captureHotkey && captureHotkey2) {
      return (
        <span>
          截屏
          <br />
          快捷键1：{captureHotkey}
          <br />
          快捷键2：{captureHotkey2}
        </span>
      );
    } else {
      return (
        <span>
          截屏
          <br />
          快捷键：{captureHotkey || captureHotkey2}
        </span>
      );
    }
  }, [localConfigData]);

  /**
   * 回车发送消息 和 alt + 回车插入新行
   * 拦截包围框的按键事件，在内部处理事件之后，不会与@ 的回车混叠
   * @param e
   */
  // eslint-disable-next-line complexity
  function handleKeyDown(e: any) {
    // console.log('handleKeyDown', e.ctrlKey, e.keyCode);
    // if (
    //     (isFocusEnv() && copyTexts && e.ctrlKey && e.keyCode === 67) ||
    //     (isMac && isFocusEnv() && copyTexts && e.metaKey && e.keyCode === 67)
    // ) {
    //     e.preventDefault();
    //     e.stopPropagation();
    //     doCopy(e);
    //     return;
    // }
    // 屏蔽pageDonw，
    if (e.key === "PageDown" || e.key === "PageUp") {
      e.preventDefault();
      e.stopPropagation();
      return;
    }
    if (!isMac && e.altKey) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }
    if (isMac && e.key === "Enter" && (e.altKey || e.metaKey)) {
      e.preventDefault();
      e.stopPropagation();
      insertText("\n");
      return;
    }
    if (e.key === "Enter" && e.shiftKey) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }
    if (sendMsgType === "1") {
      if (e.key === "Enter" && (e.ctrlKey || e.optionkey)) {
        e.preventDefault();
        e.stopPropagation();
        insertText("\n");
        return;
      }
      if (e.key === "Enter") {
        if (isCompositionModeRef.current) {
          e.stopPropagation();
        } else {
          e.preventDefault();
          e.stopPropagation();
          if (quillModal) {
            insertText("\n");
          } else {
            analysisLog("Xtbg_Msg_Info_MsgDialog", "Send_QuickEnter");
            sendMessage();
          }
        }
        return;
      }
    }
    if (sendMsgType === "2") {
      if (e.key === "Enter" && e.ctrlKey) {
        e.preventDefault();
        e.stopPropagation();
        if (quillModal) {
          insertText("\n");
        } else {
          analysisLog("Xtbg_Msg_Info_MsgDialog", "Send_QuickCtrl_Enter");
          sendMessage();
        }
        return;
      }
      if (e.key === "Enter") {
        if (isCompositionModeRef.current) {
          e.stopPropagation();
        } else {
          e.preventDefault();
          e.stopPropagation();
          insertText("\n");
        }
      }
    }
  }
  useEffect(() => {
    llmFilesRef.current = llmFiles;
  }, [llmFiles]);

  useEffect(() => {
    llmImagesRef.current = llmImages;
  }, [llmImages]);

  // 手动发送消息
  const handleSendmessage = (e: any) => {
    // console.log("handleSendmessage>ls");

    e.persist();
    sendMessage();
    focus();
  };

  const doHandleSendmessage = debounce(handleSendmessage, 300);

  const handleEnterClick = (e: any) => {
    setKeyNum(e.key);
    isFocusEnv() && FocusSDK.setHotkey("sendMsgType", e.key);
    setMsgtureType({ sendMsgType: e.key });
    if (e.key === "1") {
      setIsenter("Enter");
      setIsctrl("Ctrl + Enter");
    } else {
      setIsenter("Ctrl + Enter");
      setIsctrl("Enter");
    }
  };

  const menuStyle: React.CSSProperties = {
    padding: "4px",
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    boxShadow: "0 4px 8.2px 0 rgba(126, 126, 126, 0.25)",
    borderRadius: "6px",
    border: "1px solid #E6E6E6"
  };
  const menuItemStyle: React.CSSProperties = {
    padding: "6px",
    borderRadius: "4px",
    color: "#1B1B1B",
    fontWeight: 400
  };

  const handleChangeEditorModeClick = () => {
    setEditorMode(editorMode === "old" ? "new" : "old");
  };

  // 右下角切换方式
  const renderEnterDropdownContextMenu = () => {
    const menuItems = [
      {
        key: "1",
        label: "按Enter发送消息",
        clstag: "pageclick|keycount|Xtbg_Msg_Info_MsgDialog|Send_Enter",
        active: sendMsgType === "1"
      },
      {
        key: "2",
        label: "按Ctrl+Enter发送消息",
        clstag: "pageclick|keycount|Xtbg_Msg_Info_MsgDialog|Send_Ctrl_Enter",
        active: sendMsgType === "2"
      },
      {
        key: "3",
        label: editorMode === "old" ? "体验新版输入" : "回到旧版输入",
        clstag: "pageclick|keycount|Xtbg_Msg_Info_MsgDialog|Switch_Input_Mode",
        active: sendMsgType === "3",
        onClick: handleChangeEditorModeClick
      }
    ];
    return (
      <CustomMenu
        styleObj={{ minWidth: "124px" }}
        itemClassName="font-size-12"
        onClick={handleEnterClick}
        items={menuItems}
      />
    );
  };
  const menu = (
    <Menu style={menuStyle} selectable={true} defaultSelectedKeys={[sendMsgType]}>
      <Menu.Item
        style={menuItemStyle}
        key="1"
        onClick={handleEnterClick}
        clstag="pageclick|keycount|Xtbg_Msg_Info_MsgDialog|Send_Enter"
      >
        按Enter发送消息
      </Menu.Item>
      <Menu.Item
        style={menuItemStyle}
        key="2"
        onClick={handleEnterClick}
        clstag="pageclick|keycount|Xtbg_Msg_Info_MsgDialog|Send_Ctrl_Enter"
      >
        按Ctrl+Enter发送消息
      </Menu.Item>
      <Menu.Item
        style={menuItemStyle}
        key="3"
        onClick={handleChangeEditorModeClick}
        clstag="pageclick|keycount|Xtbg_Msg_Info_MsgDialog|Send_Ctrl_Enter"
      >
        {editorMode === "old" ? "体验新版输入" : "回到旧版输入"}
      </Menu.Item>
    </Menu>
  );

  useEffect(() => {
    let weizhi: any = document.getElementById("input-control-container"); // 输入框
    let domMessageScroll: any = document.getElementById("message-box-container-scroll");
    let isIpt: any = document.getElementById("input-box-multiline");
    let onMousedown: any = document.getElementById("input-line"); // 透明线
    let body: any = document.querySelector("body");
    let a = 0;
    const mouseDownDBClick = function (e: any) {
      if (quillModal) {
        return;
      }
      e.stopPropagation();
      e.preventDefault();
      const weizhiHeight = weizhi?.getBoundingClientRect()?.height;
      console.log(weizhiHeight, "weizhiHeight");
      console.log("dblclick");
      if (weizhiHeight === 266 || (weizhiHeight < 266 && weizhiHeight > 160)) {
        weizhi.style.height = 160 + "px";
        weizhi.style.minHeight = 160 + "px";
        weizhi.style.maxHeight = "auto";
        isIpt.style.height = 116 + "px";
        // isIpt.style.maxHeight = 50 + '%';
        state.replyVisible === true && (qlContainer.style.maxHeight = 36 + "px");
      } else {
        weizhi.style.maxHeight = 266 + "px";
        weizhi.style.height = 266 + "px";
        weizhi.style.minHeight = "auto";
        isIpt.style.height = 220 + "px";
        // isIpt.style.maxHeight = 70 + '%';
        weizhi.style.minHeight = 160 + "px";
        state.replyVisible === true && (qlContainer.style.maxHeight = 138 + "px");
      }
    };
    // 透明线双击，文本区域变最高
    onMousedown?.addEventListener("dblclick", mouseDownDBClick);
    // 获取鼠标点击位置
    const mouseDownClick = function (e: any) {
      if (domMessageScroll === null || quillModal) {
        return;
      }
      console.log("mousedown");
      let mouseDownY = e.clientY;
      let H = weizhi.offsetHeight;
      body.style.cursor = "n-resize";
      body.style.opacity = "1.1";
      body.style.position = "absolute";
      body.style.top = "0";
      body.style.left = "0";
      body.style.width = "100%";
      body.style.backgroundColor = "#fff";
      body.style.zIndex = "5000";
      document.addEventListener("mousemove", move);
      function move(e: any) {
        console.log("mousemove");
        let mouseMoveY = e.clientY;
        const weizhiHeight = mouseDownY - mouseMoveY + H;
        weizhi.style.height = `${weizhiHeight}px`;
        isIpt.style.height = `${weizhiHeight - 44}px`;
        if (weizhi) {
          domMessageScroll.scrollTop = domMessageScroll.scrollHeight;
          isIpt.scrollTop = isIpt.scrollHeight;
        }
        body.style.cursor = "n-resize";
        if (parseInt(weizhi.style.height, 10) >= 266) {
          weizhi.style.maxHeight = 266 + "px";
          isIpt.style.height = 220 + "px";
          // isIpt.style.maxHeight = 70 + '%';
          state.replyVisible === true && (qlContainer.style.maxHeight = 138 + "px");
        } else if (parseInt(weizhi.style.height, 10) <= 160) {
          weizhi.style.height = 160 + "px";
          weizhi.style.minHeight = 160 + "px";
          isIpt.style.height = 116 + "px";
          // isIpt.style.maxHeight = 50 + '%';
          state.replyVisible === true && (qlContainer.style.maxHeight = 36 + "px");
        } else {
          isIpt.style.maxHeight = "";
          state.replyVisible === true && (qlContainer.style.maxHeight = ` ${weizhiHeight - 132}px`);
        }
      }
      // (3) 鼠标弹起，就让鼠标移动事件移除
      document.addEventListener("mouseup", mouseUpEvent);
      function mouseUpEvent(evt: any) {
        console.log("mouseup");
        evt.stopPropagation();
        evt.preventDefault();
        document.onmousemove = null;
        document.onmouseup = null;
        body.style.cursor = "auto";
        document.removeEventListener("mousemove", move);
        document.removeEventListener("mouseup", mouseUpEvent);
      }
    };
    onMousedown?.addEventListener("mousedown", mouseDownClick);
    return () => {
      onMousedown?.removeEventListener("dblclick", mouseDownDBClick);
      onMousedown?.removeEventListener("mousedown", mouseDownClick);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.replyVisible, quillModal]);

  /**
   * 处理输入框样式，判断单行还是多行
   */
  function handleInputStyleChange() {
    const jeditor: any = inputRef.current;
    if (!jeditor) {
      return;
    }
    const quill = jeditor.getQuill();
    if (!quill) {
      return;
    }

    // 如果有回车或者超出一行，则变更为多行样式
    const length = quill.getLength();
    const text = quill.getText(0, length - 1);
    const index = text.indexOf("\n");
    if (index > -1) {
      setExpand(true);
      return;
    }
    // todo
    const cu: any = divEl.current;
    if (cu) {
      const div = cu.querySelector(".ql-editor");
      const width = div.scrollWidth;
      if (width > inputWidth) {
        setExpand(true);
      } else {
        setExpand(false);
      }
    }
  }
  // const node = document.querySelectorAll('#need-merge');
  async function sendMessage() {
    // 禁止操作，无法发消息
    if (!enterAllowRef.current) return;
    const quill = document.querySelector(".ql-editor") as HTMLElement;
    const fontSize = quill.style?.fontSize;
    const size_app = (fontSize && Number(fontSize.split("px")[0]) - 12) || 0;
    const size_pc = fontSize || "12px";
    const color = isSelectedColor;
    const fontStyle = {
      pc: { fontSize: size_pc, color: color },
      app: { fontSize: size_app, color: color }
    };

    if (isBanned) {
      AntMessage.warn(t(SendMessageIsBanned));
      return;
    }

    if (sessionFlags) {
      return AntMessage.warn("该群已解散！无法发送消息");
    }
    const jeditor: any = inputRef.current;
    if (!jeditor) {
      return;
    }

    // 发送消息的时候超过2000字提示
    const editor = jeditor.getQuill();
    if (editor.getLength() - 1 > 2000) {
      toast.warn("最多可输入2000字");
      return;
    }
    if (jeditor.imageCount() > 5) {
      toast.error(t("quilll-image-limit"));
      return;
    }
    // 如果输入框只有一张图片 上传图片 发送image类型消息
    const isSingleImageOnly = jeditor.isSingleImageOnly();
    if (isSingleImageOnly) {
      const file = dataURLtoFile(isSingleImageOnly.url, isSingleImageOnly.title);
      const data = await dealImagesData(file);
      uploadImg(data.imgState, data.file, true);
      jeditor.clearMessage();
      return;
    }
    if (qlContainer) {
      qlContainer.style.maxHeight = null;
    }
    let { text, userIds, delta, imageList } = jeditor.getTextMessage();
    console.log("text=>", text);
    text = text.trim();
    while (text[text.length - 1] === "\n") {
      text = text.slice(0, -1);
    }
    if (!text) {
      return;
    }
    if (isAIChatSession(selectedSession) && llmFilesRef.current?.length > 0) {
      const message = await buildMessage({
        files: llmFilesRef.current,
        sessionId: selectedSession.sessionId,
        currentEmployee,
        content: text,
        predictType: AI_CHAT_PREDICT.FILE_ANSWER
      });
      pushChatMessage({ sessionId: selectedSession.sessionId, message });
      updateLLMInfo(null);
      jeditor.clearMessage();
      return;
    }
    // 图片问答
    console.log(`tj:>>>>>>lmImagesRef.current111>>>>`, llmImagesRef.current);
    if (isAIChatSession(selectedSession) && llmImagesRef.current?.length > 0) {
      const message = await buildMessage({
        files: llmImagesRef.current,
        sessionId: selectedSession.sessionId,
        currentEmployee,
        content: text,
        predictType: AI_CHAT_PREDICT.IMG_QUIZ
      });
      console.log(`tj:>>>>>>lmImagesRef.current2222>>>`, message);
      pushChatMessage({ sessionId: selectedSession.sessionId, message });
      updateLLMInfo(null);
      jeditor.clearMessage();
      return;
    }
    if (isAIChatSession(selectedSession)) {
      if (questionHistory.length === 0) {
        const imService = ImService.getInstance();
        const aiSessionId = await getAIChatSessionId();
        if (lastMessage?.type !== ChatMessageType.SYS) {
          // 发送系统消息
          await imService?.sendSystemMessage(
            aiSessionId,
            {
              content: "开启新会话",
              type: ChatMessageType.SYS,
              flag: 11010
            },
            {
              skipCheckSession: true,
              noSend: true
            }
          );
        }
      }
      let messageBody = {
        question: text,
        isMyself: true,
        knowledgeBaseId: questionTab.current?.knowledgeBaseId || 1
      };
      const message = {
        category: "chat_message",
        sessionId: selectedSession.sessionId,
        mid: 0,
        beforeMid: 0,
        sender: currentEmployee,
        timestamp: new Date().getTime(),
        id: generateMessageId(),
        status: MessageStatus.INIT,
        type: "text",
        content: text,
        ...messageBody
      } as any;
      jeditor.clearMessage();
      pushChatMessage({ sessionId: selectedSession.sessionId, message });
      return;
    }
    // console.log("发送消息", userIds, sessionMembers);
    const uids: any[] = [];
    userIds.forEach((u: string) => {
      const temp: any = sessionMembers.find((i: any) => {
        return extraConvertEmployeeToString(i) === u;
      });
      // console.log('遍历结果', temp);
      if (temp) {
        let uid: any;
        if (temp.role === "unit") {
          uid = {
            nickname: temp.name,
            unitId: temp.unitDeptId
          };
        } else if (temp.role === "dept") {
          uid = {
            nickname: temp.name,
            deptId: temp.deptId
          };
        } else if (temp.role === "title") {
          uid = {
            nickname: temp.name,
            titleId: temp.titleId
          };
        } else {
          uid = {
            app: temp.app || "",
            teamId: temp.teamId || "",
            nickname: temp.name,
            pin: temp.userId || "",
            alias: temp.alias || ""
          };
        }
        uids.push(uid);
      }
    });
    let messageTypeOption = (await getMessageTypeByText(
      text,
      httpMatchUrls,
      blackUrls,
      isOutApp,
      isQuillMsg(delta.ops)
    )) as any;
    messageTypeOption = await nonExistentPageToText(messageTypeOption);
    if (jeditor.hasImage()) {
      text = `${t("quill-old-version-tip")}\n${text}`;
    }
    let messageBody;
    let displayContent;
    switch (messageTypeOption.type) {
      case ChatMessageType.JOYSPACEFILE:
        messageBody = await buildJoyspaceLinkMessageBody(
          text,
          messageTypeOption as JouspaceLinkTypeOption,
          uids,
          selectedSession,
          state.replyMessage
        );
        break;
      case ChatMessageType.TEXT:
      default:
        displayContent = !messageTypeOption?.is
          ? await sendMessageBody(text, [selectedSession], isOutApp, messageTypeOption.data)
          : messageTypeOption?.nativeId === "share_link"
          ? undefined
          : convertContentToArray(text, messageTypeOption.data);
        if (
          selectedSession.sessionType === SessionType.MEETING_GROUP ||
          selectedSession.sessionType === SessionType.LIVE_MEETING_GROUP
        ) {
          if (privateUser?.pin === "all") {
            messageBody = buildTextMessageBody(
              text,
              uids,
              state.replyMessage,
              messageTypeOption as HttpCardLinkTypeOption,
              displayContent,
              delta.ops,
              imageList,
              fontStyle
            );
          } else {
            messageBody = buildTextMessageBody(
              text,
              uids,
              state.replyMessage,
              messageTypeOption as HttpCardLinkTypeOption,
              displayContent,
              delta.ops,
              imageList,
              fontStyle,
              privateUser
            );
          }
        } else {
          messageBody = buildTextMessageBody(
            text,
            uids,
            state.replyMessage,
            messageTypeOption as HttpCardLinkTypeOption,
            displayContent,
            delta.ops,
            imageList
          );
        }
    }
    // console.log('messageBody', messageBody);
    // 增加atContent字段，displayContent 也需要处理
    if (messageBody.atUsers?.length > 0) {
      messageBody = handleExpandContent(messageBody, selectedSession);
    }
    const message: Partial<ChatMessage> = initChatMessageInfo({
      selectedSession: selectedSession,
      currentEmployee: currentEmployee,
      message: messageBody
    });
    const { needMerge } = getToMergeMessage(
      selectedSession,
      sessionMessageMap[selectedSession.id],
      message as ChatMessage
    );
    if (needMerge) {
      message.offlinePush = 0;
    }
    if (quillModal) {
      handleQuillInput();
    }
    bus.emit("message:Box", needMerge);
    bus.emit("message:Container", needMerge);
    pushChatMessage({ sessionId: selectedSession.sessionId, message });
    dispatch({ type: "closeReply" });
    jeditor.clearMessage();
    jeditor.events.emit("close-mention");
  }

  async function handleUploadImgs(files: any, type?: string, tableImg?: string) {
    if (isBanned) {
      AntMessage.warn(t(SendMessageIsBanned));
      return;
    }
    let noFolderFiles: any[] = [];
    if (
      ![
        SessionType.SINGLE,
        SessionType.SECRET_SINGLE,
        SessionType.GROUP,
        SessionType.MEETING_GROUP,
        SessionType.LIVE_MEETING_GROUP
      ].includes(selectedSession.sessionType)
    ) {
      return;
    }
    if (!files || (files && !files.length)) {
      return;
    } else {
      let allFilesPromise = [].slice.call(files, 0).map((item: any) => {
        return filterDirectory(item, false);
      });

      let result = await Promise.all(allFilesPromise);
      result.forEach((itemFlag, index) => {
        if (itemFlag) {
          noFolderFiles.push(files[index]);
        }
      });
      if (!noFolderFiles.length) {
        AntMessage.warn("暂不支持发送文件夹，您可以将文件夹压缩后发送");
        return;
      }
    }
    dispatch({ type: "clearImageState" });
    if (noFolderFiles.length > 1) {
      setMulti(true);
      let typeList: any[] = [];
      noFolderFiles.forEach(async (file: any) => {
        const promise = filterImages(file);
        typeList.push(promise);
      });
      // console.log('typeList', typeList);
      Promise.all(typeList).then((result) => {
        const isAllImages = result.every((item) => item); // 是否全部选择的图片类型
        if (isAllImages) {
          // 先弹框，在处理旋转问题
          dispatch({
            type: "openUploadImgModal",
            payload: {
              imgState: state.imgState,
              file: state.file,
              fileList: noFolderFiles
            }
          });
        } else {
          uploadFile(noFolderFiles);
        }
      });
    } else {
      setMulti(false);
      const file = noFolderFiles[0];
      // console.log('单张图片', file);
      const isImage = await filterImages(file);
      // console.log('isImage', isImage);
      if (!isImage) {
        uploadFile([file]);
        return;
      }
      const fileName = `${APP_NAME}_${nyrssfENStr(new Date().getTime())}.png`;
      let tempFile = file.name === "image.png" ? new File([file], fileName) : file;
      // const isHeic = await isHeicImage(tempFile);
      // if (isHeic) {
      //     tempFile = await heicToPng(tempFile);
      // }
      const data = await dealImagesData(tempFile, tableImg);
      // 富文本模式&图片小于2M直接插入输入框
      const jeditor: any = inputRef.current;
      if (!jeditor) {
        return;
      }
      let weizhi: any = document.getElementById("input-control-container");
      const height = weizhi.style.height;
      if (height === "500px" && data.file.size < chatConfig["insert-max-image-size"]) {
        jeditor.insertImage({
          url: data.imgState.base64,
          width: data.imgState.width,
          height: data.imgState.height,
          title: data.imgState.title
        });
        dispatch({ type: "closeUploadImgModal" });
        return;
      }
      if (type !== "captureImg") {
        dispatch({
          type: "openUploadImgModal",
          payload: { ...data, fileList: [] }
        });
      } else {
        return data;
      }
    }
  }

  function closeUploadImgModal() {
    dispatch({ type: "closeUploadImgModal" });
    setTimeout(() => {
      dispatch({ type: "clearImageState" });
    }, 0);
  }

  async function sendImg(
    selectedImgs?: any,
    isOrigin?: boolean,
    withParam?: boolean,
    params?: any
  ) {
    dispatch({ type: "closeUploadImgModal" });
    if (isMulti) {
      uploadMultiImg(selectedImgs, isOrigin);
    } else {
      if (withParam) {
        uploadImg(params.imgState, params.file, isOrigin);
      } else {
        uploadImg(state.imgState, state.file, isOrigin);
      }
    }
    // setTimeout(() => {
    //     dispatch({ type: 'clearImageState' });
    // }, 2000);
  }

  function insertText(str: string) {
    const jeditor = inputRef.current;
    if (!jeditor) {
      return;
    }
    console.log("inserText=>", str);
    jeditor.insertText(str);
  }

  function repaceText(str: string) {
    const jeditor = inputRef.current;
    if (!jeditor) {
      return;
    }
    console.log("repaceText=>", str);
    jeditor.clearMessage();
    jeditor.insertText(str);
  }

  function handleAtClick(e: any) {
    insertText("@");
    dispatch({
      type: "handleAtClick"
    });
  }

  function handlemeetingClick() {
    insertText("@");
    dispatch({
      type: "handlemeetingClick"
    });
  }

  function handleQuickReplyClick(visible: boolean) {
    // 打开常用语时 关闭@
    if (visible) {
      closeMention();
    }
    dispatch({
      type: "changeQuickReplyVisible",
      payload: { quickReplyVisible: visible }
    });
  }

  useEffect(() => {
    if (!offCaptureHandle && isFocusEnv()) {
      offCaptureHandle = FocusSDK.onIpcMessage("captureHandle", async (data: any) => {
        const { type, url } = data;
        if (type === "share") {
          // 暂时处理方案，截屏分享操作监听会触发多次
          forwardOperate(url);
        } else if (type === "complete") {
          // 群禁言或者是系统消息不弹出发送弹窗
          toast.success("截屏已完成，请您在需要处粘贴");
          // if (
          //   !isBanned ||
          //   [SessionType.SINGLE, SessionType.SECRET_SINGLE, SessionType.GROUP].includes(
          //     selectedSession.sessionType
          //   )
          // ) {
          //   const fileName = `京办_${nyrssfENStr(new Date().getTime())}.png`;
          //   const file = dataURLtoFile(url, fileName);
          //   handleUploadImgs([file]);
          // }
        } else {
          console.log(data);
        }
      });
    }
    return () => {
      if (offCaptureHandle) {
        offCaptureHandle();
      }
      offCaptureHandle = null;
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isBanned, offCaptureHandle, selectedSession.sessionType]);

  // 截屏按钮点击
  function handleCaptureClick() {
    setTimeout(() => {
      // 是否隐藏当前窗口
      // if (captureType === "1") {
      //   FocusSDK.sendMainMessage("mainHide", {}, () => {
      //     console.log("发送了mainHide");
      //   });
      // }

      // 截屏api调用
      FocusSDK.captureScreen((data) => {
        console.log(data);
      });
    }, 300);
  }

  // 会议聊天记录保存
  async function handleMeetingSave(sid: string) {
    const res = await ImService.getInstance()?.exportMessages(sid);
    const fileName = "聊天记录";
    const file = new File([JSON.stringify(res)], fileName);
    const task = createUploadTask(sid, file, {
      appKey: "i2u1l800lb2qh65n",
      bizType: getFileDownloadBzType(selectedSession),
      bizId: getFileDownloadBzId(selectedSession)
    });
    if (task) {
      task.on("state", async (state1: any) => {
        if (state1.state === "completed") {
          if (!state1.downloadUrl) return;
          const fileUrl = state1.downloadUrl.split("?")[0];
          const conferenceCode = getChatMeetingCode(sid);
          const saveParams = {
            url: fileUrl,
            appKey: "i2u1l800lb2qh65n",
            conferenceCode: conferenceCode
          };
          saveChatRecord(saveParams);
          setsaveRecordtip(true);
          setTimeout(() => {
            setsaveRecordtip(false);
          }, 5000);
        }
      });
      task?.start();
    }
  }

  function handleMeetingSetting() {
    // 权限改变
    const sid = selectedSession?.sessionId;
    const session = { ...selectedSession };
    const onChange = (permission: number) => {
      // 设置权限
      modifyChatPermission({
        conferenceCode: getChatMeetingCode(sid),
        chatPermission: permission
      })
        .then(() => {
          if (!session) {
            return;
          }
          session.settings = {
            ...session.settings,
            permissionEnum: permission
          };
          bus.emit("chat:session-update", session);
        })
        .catch((e) => {
          console.log("handleMeetingSetting err", e);
        });
      handlePermissionVisible(false);
    };
    return (
      <div className="permission-list">
        <div className="permission-list-title">会议中聊天权限</div>
        {permissionText.map((val, index) => {
          return (
            <div
              key={index}
              className="permission-list-item"
              onClick={() => {
                onChange(index);
              }}
            >
              {index === selectedSession?.settings?.permissionEnum || 0 ? (
                <img src={selected} />
              ) : (
                <span style={{ width: 12, height: 9 }} />
              )}
              <div className="permission-list-item-content">{permissionText[index]}</div>
            </div>
          );
        })}
      </div>
    );
  }

  function getMaskHeight() {
    let chatContainer: any = document.getElementsByClassName("chat-container")[0];
    if (!chatContainer) {
      return;
    }
    let style = window.getComputedStyle(chatContainer);
    maskHeight.current = `${parseInt(style.height, 10) - 500}px`;
  }

  function handleQuillInput() {
    const jeditor: any = inputRef.current;
    if (!jeditor) {
      return;
    }
    const quill = jeditor.getQuill();
    if (!quill) {
      return;
    }
    quill.focus();
    let weizhi: any = document.getElementById("input-control-container");
    let inputLine: any = document.getElementById("input-line");
    const height = weizhi.style.height;
    if (height !== "500px") {
      weizhi.style.maxHeight = "500px";
      weizhi.style.height = "500px";
      inputLine.style.cursor = "default";
      setQuillModal(true);
      jeditor.setQuillModal(true);
      getMaskHeight();
    } else {
      weizhi.style.height = "160px";
      inputLine.style.cursor = "n-resize";
      setQuillModal(false);
      jeditor.setQuillModal(false);
    }
  }

  function handleShareCardClick() {
    return shareUserCard();
  }

  // 生成截屏图片的消息体
  const buildCaptureImageMessage = async (url: string, item: any) => {
    const fileName = `${APP_NAME}_${nyrssfENStr(new Date().getTime())}.png`;
    const file = dataURLtoFile(url, fileName);
    const fileData = await handleUploadImgs([file], "captureImg");
    const { imgState } = fileData;
    // 创建上传任务，将截屏图片上传
    const imService = ImService.getInstance();
    // TODO: 目前只处理单聊
    const type = item.isSecret ? SessionType.SECRET_SINGLE : SessionType.SINGLE;
    const to = {
      ...item,
      ...(item.origin?.uid || {})
    };
    const sessionId = item.isGroup
      ? item.id
      : imService.generateSingleSessionId(currentEmployee, to, type);
    const session: any = {
      sessionId
    };
    const task = createUploadTask(sessionId, fileData.file);
    if (task) {
      task.on("state", async (state1: any) => {
        if (state1.state === "completed") {
          if (!state1.downloadUrl) return;
          const message: Partial<ChatMessage> = buildImageMessageBody(
            state1.downloadUrl,
            file.size,
            imgState.width,
            imgState.height
          );
          if (privateUser?.pin && privateUser?.pin !== "all") {
            message.to = { ...privateUser };
          }
          const chatMessage = initChatMessageInfo({
            selectedSession: session,
            currentEmployee: currentEmployee,
            message: message,
            task: task
          });
          const messageBody = omit(cloneDeep(chatMessage), [
            "status",
            "taskId",
            "task",
            "mid",
            "beforeMid",
            "sessionId",
            "groupId",
            "statusType"
          ]) as any;

          imService.sendChatMessage(session.sessionId, chatMessage.id as string, messageBody);
        }
      });
      task?.start();
    } else {
      log.warn("创建上传任务失败=======>", JSON.stringify(file));
    }
  };

  // 人员选择器调起
  const forwardOperate = (url: string) => {
    // props.unLock();
    // const fixedUsers = getSelectorSessions(allSessionList);
    openUserSelectionModal(
      {
        title: t("select-session-contacts"),
        // fixedUsers: fixedUsers,
        frozenIds: [],
        currentUser: employeeToUid(currentEmployee),
        // mode: SelectorMode.forward,
        mode: SelectorMode.user,
        tabs: config[ConfigEnum.EXTERNAL_CONTACTS_ORG]
          ? ["recentIncludeGroup", "org", "groupCanBeSel", "externalContacts"]
          : ["recentIncludeGroup", "groupCanBeSel", "externalContacts"]
      },
      (data, close) => {
        doExitAndForward(data, close, url);
      },
      userData
    );
  };

  const exitAndForward = async (data: any, url: string) => {
    const list = get(data, "data.result", []);
    if (!list || list.length <= 0) {
      return;
    }
    console.log(list, "sessions");
    list.forEach((item: any) => {
      buildCaptureImageMessage(url, item);
    });
  };

  const doExitAndForward = debounce(async (data: any, close, url: string) => {
    // 等待消息转发完成以后关闭窗口
    await exitAndForward(data, url);
    close();
  }, 500);

  function handleAtVisibleChange(visible: boolean) {
    if (visible) {
      dispatch({
        type: "handleAtClick"
      });
    }
  }

  function handlemeetingVisibleChange(visible: boolean) {
    if (visible) {
      dispatch({
        type: "handlemeetingClick"
      });
    }
  }

  function handleQuickReplyItemClick(detail: any) {
    // 需求变更 常用语会变三行，同意类，中性类，反对类。点击后到输入框中，不是直接发送
    const jeditor = inputRef.current;
    if (!jeditor) {
      return;
    }
    const quill = jeditor.getQuill();
    if (!quill) {
      return;
    }
    quill.focus();
    setTimeout(() => {
      const range = quill.getSelection();
      if (!range) return;
      quill.setText(detail);
      quill.setSelection(detail.length + 1, 0);
    });
    dispatch({ type: "closeReply" });
    focus();
  }

  function handleImgClick() {
    if (isBanned) {
      AntMessage.warn(t(SendMessageIsBanned));
      return;
    }
    // 点击图片关闭常用语、表情、@modal框
    dispatch({
      type: "handleImgClick"
    });
    closeMention();
    const input = document.createElement("INPUT");
    document.body.appendChild(input);
    input.setAttribute("type", "file");
    input.setAttribute("multiple", "true");
    input.setAttribute("accept", "image/png,image/jpeg,image/gif,image/bmp,image/webp");
    document.body.appendChild(input);
    input.onchange = (ev: any) => {
      if (ev.target.files) {
        handleUploadImgs(ev.target.files);
      }
    };
    input.click();
    document.body.removeChild(input);
  }

  async function handleEmojiClick(str: string) {
    const jeditor = inputRef.current;
    if (!jeditor) {
      return;
    }
    const quill = jeditor.getQuill();
    if (!quill) {
      return;
    }
    quill.focus();
    setTimeout(() => {
      const range = quill.getSelection();
      if (!range) return;
      const { index } = range;
      const Delta = Quill.import("delta");
      // console.log('变前', str, str.length);
      // const temp = str === '✌' ? '✌️' : str === '☕' ? '☕️' : str;
      // console.log('变后', temp, temp.length);
      quill.updateContents(
        new Delta().retain(index).insert({
          // 'custom-emoji': str,
          // 为了兼容移动端这两个表情显示错误做了如下处理，移动端这个表情的长度为2，桌面端为1，所以当匹配到这个表情时，替换为新的
          "custom-emoji": str === "✌" ? "✌️" : str === "☕" ? "☕️" : str
        }),
        "user"
      );
      quill.setSelection(index + 1, 0);
    });
  }

  function handleFileClick(multi?: boolean) {
    closeOtherModal();
    if (isBanned) {
      AntMessage.warn(t(SendMessageIsBanned));
      return;
    }
    const input = document.createElement("INPUT");
    input.setAttribute("type", "file");
    if (multi) {
      input.setAttribute("multiple", "true");
    }
    input.onchange = (ev: any) => {
      if (ev.target.files && ev.target.files.length > 0) {
        if (multi) {
          uploadFile(ev.target.files);
        } else {
          uploadFile(ev.target.files[0]);
        }
      }
    };
    input.click();
  }
  function handleFileClickAI() {
    closeOtherModal();
    if (isBanned) {
      AntMessage.warning(t(SendMessageIsBanned));
      return;
    }
    const input = document.createElement("INPUT");
    input.setAttribute("type", "file");
    input.setAttribute("accept", `${previewAllowSuffix.join(",")}`);

    input.setAttribute("multiple", "true");

    input.onchange = (ev: any) => {
      // console.log(ev.target.files, "ev.target.files>ls");
      const limit = 5;
      if (ev.target.files && ev.target.files.length > 0) {
        if (ev.target.files.length > limit) {
          AntMessage.warn(t1("AI.local-file-limit", { num: limit }));
          return;
        }
        let error = 0;
        const files = Array.from(ev.target.files).map((file: any) => {
          const name = file.name;
          const result = previewAllowSuffix.find((item: string) => {
            return new RegExp(`.${item}$`).test(name.toLocaleLowerCase());
          });
          if (!result) {
            error++;
          }
          return {
            file: file,
            fileName: file.name,
            isUpload: true
          };
        });
        if (error) {
          AntMessage.warn(t1("AI.local-file-tip"));
          return;
        }
        updateLLMInfo({
          files: files,
          isReady: false
        });
      }
    };
    input.click();
  }

  function handleImageClickAI() {
    closeOtherModal();
    if (isBanned) {
      AntMessage.warning(t(SendMessageIsBanned));
      return;
    }
    const input = document.createElement("INPUT");
    input.setAttribute("type", "file");
    input.setAttribute("accept", `${ALLOW_IMAGE_TYPE.join(",")}`);

    input.setAttribute("multiple", "true");

    input.onchange = (ev: any) => {
      const limit = 5;
      if (ev.target.files && ev.target.files.length > 0) {
        if (ev.target.files.length > limit) {
          AntMessage.warn(t1("AI.local-file-limit", { num: limit }));
          return;
        }
        let error = 0;
        const files = Array.from(ev.target.files).map((file: any) => {
          const name = file.name;
          return {
            file: file,
            fileName: file.name,
            isUpload: true
          };
        });
        if (error) {
          AntMessage.warn(t1("AI.local-file-tip"));
          return;
        }
        updateLLMInfo({
          images: files,
          isReady: false,
          type: "add"
        });
      }
    };
    input.click();
  }

  // 选择文档后上报
  function exportJoyspaceLog(list: any[]) {
    let types: any[] = [];
    let ids: any[] = [];
    list.forEach((item: any) => {
      types.push(item.pageType || item.type);
      ids.push(item.id);
    });
    analysisLog(
      "xtbg_jzb_joysapce_inOtherModule_1676971574856",
      "18",
      types.join("/"),
      ids.join("/")
    );
  }

  // 生成URL
  function caertJoySpaceLink(data: any) {
    let content;
    if (data.pageType === PageType.Form) {
      // 低代码
      content = data.link;
      return content;
    }
    const { joyspaceHost } = appRuntimeEnv;
    const path = buildPagePathKey(data.pageType).subPath;
    const link = `${joyspaceHost}/${path}/${data.id}`;
    return `${link}`;
  }

  function callback({
    status,
    callbackId,
    results
  }: {
    status: "ok" | "cancel";
    callbackId: string;
    results: any;
  }) {
    console.log("callbacktest:chat", callbackId);
    const { sessionId } = selectedSession;
    if (selectedSession.sessionId !== callbackId) {
      return;
    }

    if (status === "cancel") {
      return;
    }
    if (results.length === 0) {
      return;
    }
    const list = results.map((item: any) => {
      return {
        content: "",
        icon: item.icon,
        title: item.title,
        type: item.type,
        pageType: item.pageType,
        id: item.id,
        permissionType: item.permissionType,
        url: caertJoySpaceLink(item),
        from: item.from
      };
    });
    // 选择文档完成后上报日志
    exportJoyspaceLog(list);
    sendJoyspaceMessage(list);
  }

  function handleJoySpaceClick() {
    if (isFocusEnv()) {
      log.debug("handleJoySpaceClick", selectedSession, currentEmployee);
      const { sessionType, sessionId, info } = selectedSession;
      let pin = sessionId;
      let teamId = "";
      let app = "";
      if (sessionType === SessionType.SINGLE || sessionType === SessionType.SECRET_SINGLE) {
        const employee = info as EmployeeAttribute;
        if (!employee) {
          log.error("handleJoySpaceClick can not get uid", { sessionType });
          return;
        }
        pin = employee.userId;
        teamId = employee.teamId;
        app = employee.app;
      }
      if (sessionType === SessionType.GROUP) {
        teamId = currentEmployee.teamId;
        app = currentEmployee.app;
      }
      // FocusSDK.once("openJoyspaceDocSelector:result", callback);
      FocusSDK.emit("openJoyspaceDocSelector", { callbackId: selectedSession.sessionId, callback });
      // FocusSDK.shareDocuments(
      //     {
      //         pin,
      //         sessionType,
      //         teamId,
      //         app,
      //     },
      //     (data: any) => {
      //         logger.debug('shareDocuments result', data);
      //         sendJoyspaceMessage(data);
      //     }
      // );
    } else {
      focusSDK.emit("openJoyspaceCloudSelector", {
        callbackId: "chat-cloud-file",
        callback: (data: any) => {
          console.log("data---", data);
          const { joyspaceApiHost } = appRuntimeEnv;
          const list = data.map((item: any) => {
            return {
              ...item,
              content: "",
              url: caertJoySpaceLink(item)
            };
          });
          // 文档选择完成后上报
          exportJoyspaceLog(list);
          sendJoyspaceMessage(list);
        }
      });
    }
  }

  // 创建组空间
  async function groupCreate() {
    const owner = (selectedSession as any)?.info || {};
    const { gid } = owner;
    const gname = owner.name;
    const description = owner.intro;

    const onLine = await netServer.checkNet();
    if (!onLine) {
      toast.error(i18n.t("Network Error"));
      return;
    }
    let groupList = groupRosters;
    try {
      if (Array.isArray(groupList) && !groupList.length) {
        const { data } = await getGroupMemberList(gid, "group");
        groupList = data || [];
      }
      console.log("群信息", groupList);
      if (!groupList.length) {
        toast.error("该群已解散");
        // return;
      }

      let admins: any = [];
      for (let item of groupList) {
        if (item.identity === "administrator" || item.identity === "sub_administrator") {
          admins.push((item as any).info.userId);
        }
      }
      let result = await groupCreates({
        admins,
        folderId: gid,
        name: gname,
        description,
        parent: "groupRoot"
      });
      if (!result || result.errMsg) {
        toast.error("create_group_team_space_error");
      }
    } catch (e) {
      console.error(e, "=asdadadasdadasdad");
      e && toast.error(e);
    }
  }

  function handleGroupSpace() {
    groupCreate().then(() => {
      if (isFocusEnv()) {
        log.debug("handleGroupSpace", selectedSession, currentEmployee);
        const { sessionId } = selectedSession;

        // FocusSDK.once("openJoyspaceDocSelector:result", callback);
        FocusSDK.emit("openJoyspaceDocSelector", {
          callbackId: sessionId,
          groupInfo: { gid: (selectedSession as any)?.info.gid },
          callback
        });
      } else {
        focusSDK.emit("openJoyspaceCloudSelector", {
          callbackId: "chat-groupspace-file",
          groupInfo: {
            gid: (selectedSession as any)?.info.gid
          },
          callback: (data: any) => {
            console.log("data---", data);
            const list = data.map((item: any) => {
              return {
                ...item,
                content: "",
                url: caertJoySpaceLink(item),
                from: item.from
              };
            });
            // 文档选择完成后上报
            exportJoyspaceLog(list);
            sendJoyspaceMessage(list);
          }
        });
      }
    });
  }

  function handleEmojiVisible(visible: boolean) {
    // 点击表情关闭@modal框
    if (visible) {
      closeMention();
    }
    dispatch({
      type: "changeEmojiVisible",
      payload: { visible, quillModal: quillModal }
    });
  }

  function handleFontVisible(visible: boolean) {
    // 点击字体关闭@modal框
    if (visible) {
      closeMention();
    }
    dispatch({
      type: "changeFontVisible",
      payload: { visible }
    });
  }
  function handlePermissionVisible(visible: boolean) {
    // 点击字体关闭@modal框
    if (visible) {
      closeMention();
    }
    dispatch({
      type: "changePermissionVisible",
      payload: { visible }
    });
  }

  function handlelistVisible(visible: boolean) {
    // 点击字体关闭@modal框
    if (visible) {
      closeMention();
    }
    dispatch({
      type: "changelistVisible",
      payload: { visible: visible && isShowmodal }
    });
  }

  // 点击+号关闭常用语和@modal框
  function closeOtherModal() {
    closeMention();
  }

  // 鼠标右键
  function onContextMenu(e: any) {
    e.preventDefault();
    e.stopPropagation();
    const inputControl: any = document.getElementById("input-control-container");
    const cw = inputControl.clientWidth;
    const cu = inputControl.clientHeight;
    const copyText: any = window.getSelection()?.toString();
    const onCw = cw - (document.body.clientWidth - e.clientX);
    const onCu = cu - (document.body.clientHeight - e.clientY);

    const clientX = onCw > cw - 68 ? cw - (document.body.clientWidth - e.clientX) - 68 : onCw;
    const clientY =
      onCu > cu - 84
        ? cu - (document.body.clientHeight - e.clientY) - copyText || copyTexts
          ? onCu - 42
          : onCu - 84
        : onCu;
    const dom: any = document.getElementsByClassName("input-copy-paste")[0] || null;
    if (dom) {
      inputRef.current?.focus();
      document.execCommand("paste");
      bus.emit("changePasteType", "click");
      dom.style.top = clientY + "px";
      dom.style.left = clientX + "px";
      setTimeout(() => {
        setpasteVisible(true);
        if (copyText || copyTexts) {
          setcopyVisible(true);
        }
      }, 300);
    }
  }
  // 关闭复制粘贴div
  function closeContextMenu() {
    setpasteVisible(false);
    setcopyVisible(false);
    setPasteTableImg(false);
    setTempTableImgFiles([]);
    setPastData({});
  }
  // 鼠标左键
  function doMouseDown(e: any) {
    e.stopPropagation();
    if (e.button === 2) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }
    if (e.target.className === "paste-space_img") {
      doTableImgPaste(e);
      return;
    }
    if (e.target.className === "paste-space") {
      doPaste(e);
      return;
    } else if (e.target.className === "paste-copy") {
      doCopy(e);
      return;
    }
    closeContextMenu();
  }

  function getRightMenu() {
    if (selectedSession.uid?.pin?.startsWith("robot_")) {
      // 应用机器人单聊会话页工具条置空
      // menus.splice(0, menus.length);
      return <div style={{ width: "100%", height: "20px" }} />;
    }
    const menus: any[] = [];
    // 表情
    if (config[ChatConfig.CHAT_MESSAGE_INPUT_EMOJI]) {
      menus.push(
        <EmojiPopover
          key="1"
          onclick={handleEmojiClick}
          visible={state.emojiVisible}
          onVisibleChange={handleEmojiVisible}
        >
          <Tooltip title={t("emoji")} placement="top">
            <IconFont className="expression input-button" type="iconic_app_im_expression" />
          </Tooltip>
        </EmojiPopover>
      );
    }
    // 会议聊天窗口：字体样式
    if (
      [SessionType.MEETING_GROUP, SessionType.LIVE_MEETING_GROUP].includes(
        selectedSession.sessionType
      )
    ) {
      menus.push(
        <FontPopover key="2" visible={state.fontVisible} onVisibleChange={handleFontVisible}>
          <Tooltip title={t("font")} placement="top">
            <IconFont className="expression input-button" type="iconic_pc_meeting_text" />
          </Tooltip>
        </FontPopover>
      );
    }
    // 会议聊天窗口：保存聊天记录
    if (
      crossAppSwitch("joyspace") &&
      [SessionType.MEETING_GROUP].includes(selectedSession.sessionType)
    ) {
      menus.push(
        <Tooltip title={t("save")} placement="top">
          <IconFont
            className="expression input-button record-save"
            type="iconic_pc_meeting_save"
            onClick={() => handleMeetingSave(selectedSession.sessionId)}
          />
        </Tooltip>
      );
    }
    // 会议聊天窗口：聊天权限设置
    if (
      [SessionType.MEETING_GROUP, SessionType.LIVE_MEETING_GROUP].includes(
        selectedSession.sessionType
      )
    ) {
      const isMaster = isGroupAdmin(groupRosterIdentity) || isGroupOwner(groupRosterIdentity);
      isMaster &&
        menus.push(
          <Popover
            placement="topRight"
            content={handleMeetingSetting}
            trigger="click"
            visible={state.permissionVisible}
            onVisibleChange={handlePermissionVisible}
          >
            <Tooltip title={t("setting")} placement="top">
              <IconFont
                className="expression input-button permission-set"
                type="iconic_pc_meeting_setting"
              />
            </Tooltip>
          </Popover>
        );
    }
    // 图片
    if (
      config[ChatConfig.CHAT_MESSAGE_INPUT_IMAGE] &&
      ![SessionType.LIVE_MEETING_GROUP].includes(selectedSession.sessionType)
    ) {
      menus.push(
        <Tooltip key="3" title={t("image")} placement="top">
          <IconFont
            className="pic input-button"
            type="iconic_app_im_picture"
            onClick={handleImgClick}
            clstag={
              quillModal
                ? "pageclick|keycount|Xtbg_Msg_Info_MsgDialog|RichTextMessage_Pic"
                : "pageclick|keycount|Xtbg_Msg_Info_MsgDialog|AddPic"
            }
          />
        </Tooltip>
      );
      if (!isFocusEnv() && selectedSession.isSingle && quillModal) {
        menus.push(<div key="4" className="sort-line" />);
      }
    }
    // 截屏
    if (
      config[ChatConfig.CHAT_MESSAGE_INPUT_CAPTURE] &&
      isFocusEnv() &&
      !selectedSession.isSecret &&
      ![SessionType.MEETING_GROUP, SessionType.LIVE_MEETING_GROUP].includes(
        selectedSession.sessionType
      )
    ) {
      menus.push(
        <ScreenCapture>
          {/* <span className="capture-icon-container">
            <IconFont
              className="at input-button capture-icon"
              type="iconic_pc_im_screenshot1"
              onClick={handleCaptureClick}
              clstag="pageclick|keycount|focus_chat_01_1602584371145|42"
            />
            <span className="capture-tips">{captureTips}</span>
          </span> */}
          <Tooltip key="8" title={captureTips} placement="top">
            <IconFont
              className="at input-button capture-icon"
              type="iconic_pc_im_screenshot1"
              onClick={handleCaptureClick}
              clstag={
                quillModal
                  ? "pageclick|keycount|Xtbg_Msg_Info_MsgDialog|RichTextMessage_SCreenShot"
                  : "pageclick|keycount|focus_chat_01_1602584371145|42"
              }
            />
          </Tooltip>
        </ScreenCapture>
      );
      if (quillModal && selectedSession.isSingle) {
        menus.push(<div key="4" className="sort-line" />);
      }
    }
    // @
    if (
      config[ChatConfig.CHAT_MESSAGE_INPUT_AT] &&
      !selectedSession.isSingle &&
      ![SessionType.MEETING_GROUP, SessionType.LIVE_MEETING_GROUP].includes(
        selectedSession.sessionType
      )
    ) {
      menus.push(
        <Tooltip key="10" title={t("@remind")} placement="top">
          <IconFont
            className="at input-button"
            type="iconic_app_im_mention"
            onClick={handleAtClick}
            clstag={
              quillModal
                ? "pageclick|keycount|Xtbg_Msg_Info_MsgDialog|RichTextMessage_AtService"
                : "pageclick|keycount|Xtbg_Msg_Info_MsgDialog|AtService"
            }
          />
        </Tooltip>
      );
      if (quillModal) {
        menus.push(<div key="4" className="sort-line" />);
      }
    }
    if (
      config[ChatConfig.CHAT_MESSAGE_INPUT_FILE] &&
      !quillModal &&
      ![SessionType.LIVE_MEETING_GROUP].includes(selectedSession?.sessionType)
    ) {
      menus.push(
        <Tooltip key="11" title={t("file_menu")} placement="top">
          <IconFont
            className="at input-button"
            type="iconbendiwenjian1"
            onClick={() => {
              handleFileClick(true);
            }}
            clstag="pageclick|keycount|Xtbg_Msg_Info_MsgDialog|UploadDoc"
          />
        </Tooltip>
      );
    }
    if (
      !selectedSession.isSecret &&
      config[ChatConfig.CHAT_MESSAGE_INPUT_JOYSPACE] &&
      !isOutApp &&
      ![SessionType.MEETING_GROUP, SessionType.LIVE_MEETING_GROUP].includes(
        selectedSession?.sessionType
      ) &&
      // 解决移动端基于日程创建的群组，在pc端没有云文件入口的bug
      !(
        selectedSession.isSingle &&
        (selectedSession.info as EmployeeAttribute)?.app !== currentEmployee.app
      ) &&
      !quillModal
    ) {
      menus.push(
        <Tooltip key="12" title={t("joyspace_menu")} placement="top">
          <IconFont
            className="at input-button"
            type="iconwendangxietong1"
            onClick={handleJoySpaceClick}
            clstag="pageclick|keycount|Xtbg_Msg_Info_MsgDialog|CloudDoc"
          />
        </Tooltip>
      );
    }
    if (
      selectedSession.isGroup &&
      config[ChatConfig.CHAT_MESSAGE_INPUT_GROUP_SPACE] &&
      !isOutApp &&
      !quillModal &&
      ![SessionType.MEETING_GROUP].includes(selectedSession?.sessionType)
    ) {
      menus.push(
        <Tooltip key="13" title={t("groupspace_menu")} placement="top">
          <IconFont className="at input-button" type="iconzukongjian2" onClick={handleGroupSpace} />
        </Tooltip>
      );
    }
    // {config[ChatConfig.CHAT_MESSAGE_INPUT_FILE] && (
    //   <Menu.Item
    //     onClick={() => {handleFileClick(true)}}
    //     clstag="pageclick|keycount|Xtbg_Msg_Info_MsgDialog|UploadDoc"
    //   >
    //     <div className="more-menu-operate-item">
    //       <IconFont
    //         className="chat-input-more-menu-icon iconic_app_more_file"
    //         type="iconic_app_more_file"
    //       />
    //       <span className="menu-text">{isBjme() ? t("local-file") : t("file")}</span>
    //     </div>
    //   </Menu.Item>
    // )}
    // // 分享名片
    // if (
    //   config[ChatConfig.CHAT_MESSAGE_INPUT_SHARE_CARD] &&
    //   !selectedSession.isSecret &&
    //   ![SessionType.MEETING_GROUP, SessionType.LIVE_MEETING_GROUP].includes(
    //     selectedSession.sessionType
    //   ) &&
    //   !quillModal
    // ) {
    //   menus.push(
    //     <Tooltip key="11" title={t("share_card")} placement="top">
    //       <IconFont
    //         className="at input-button"
    //         type="iconic_pc_businesscard"
    //         onClick={handleShareCardClick}
    //       />
    //     </Tooltip>
    //   );
    // }
    // 常用语
    // if (config[ChatConfig.CHAT_MESSAGE_INPUT_CHANG]) {
    //     menus.push(
    //         <QuickReplyComp
    //             visible={state.quickReplyVisible}
    //             onItemClick={handleQuickReplyItemClick}
    //             key={selectedSession.id}
    //             onVisibleChange={handleQuickReplyClick}
    //             quickReplys={quickReplys}
    //         >
    //             <Tooltip key="7" title={t('quickReply')} placement="top">
    //                 <IconFont className="at input-button" type="icona-ic_app_im_Commonlyused" />
    //             </Tooltip>
    //         </QuickReplyComp>
    //     );
    // }
    // +号
    if (config[ChatConfig.CHAT_MESSAGE_INPUT_FILE_IN_MENU] && !quillModal) {
      if (config[ChatConfig.CHAT_MESSAGE_INPUT_FILE]) {
        if (menus.length > 0) {
          menus.push(<div key="4" className="sort-line" />);
        }
        menus.push(
          <Tooltip key="5" title={t("file")} placement="top" className="sort-line-tip">
            <IconFont
              className="chat-input-more-menu-icon"
              type="iconapp_btn_folder"
              onClick={() => {
                handleFileClick();
              }}
            />
          </Tooltip>
        );
      }
    } else {
      if (
        config[ChatConfig.CHAT_MESSAGE_INPUT_MORE] &&
        ![SessionType.LIVE_MEETING_GROUP].includes(selectedSession.sessionType) &&
        !quillModal
      ) {
        if (menus.length > 0) {
          menus.push(<div key="4" className="sort-line" />);
        }
        menus.push(
          <MoreDropdown
            key="6"
            // handleUploadImgs={handleUploadImgs}
            uploadFile={
              isBanned
                ? () => {
                    AntMessage.warn(t(SendMessageIsBanned));
                  }
                : uploadFile
            }
            sendJoyspaceMessage={sendJoyspaceMessage}
            closeOtherModal={closeOtherModal}
          >
            <IconFont className="add input-button sort-icon" type="icona-ic_app_im_Addto" />
          </MoreDropdown>
        );
      }
    }
    // 富文本编辑
    if (
      ![SessionType.MEETING_GROUP, SessionType.LIVE_MEETING_GROUP].includes(
        selectedSession.sessionType
      ) &&
      !selectedSession.isSecret
    ) {
      if (quillModal) {
        menus.push(
          <Tooltip title="收起" placement="top">
            <IconFont
              className="quill-input input-button"
              type="iconic_pc_close"
              onClick={handleQuillInput}
              clstag="pageclick|keycount|Xtbg_Msg_Info_MsgDialog|RichTextMessage"
            />
          </Tooltip>
        );
      } else {
        menus.push(
          <Tooltip title="展开" placement="top">
            <IconFont
              className="quill-input quill-input-open input-button"
              type="iconic_pc_Expand"
              onClick={handleQuillInput}
              clstag="pageclick|keycount|Xtbg_Msg_Info_MsgDialog|RichTextMessage"
            />
          </Tooltip>
        );
      }
    }

    return (
      <div
        className={`${!expand ? "" : "input-control-container-multRight"}
        ${
          [SessionType.MEETING_GROUP, SessionType.LIVE_MEETING_GROUP].includes(
            selectedSession.sessionType
          )
            ? "input-control-container-multRight-meeting"
            : ""
        }`}
        style={
          inputDisable || isMeetingBanned || sessionFlags
            ? {
                //   opacity: 0.5,
                pointerEvents: "none"
              }
            : {}
        }
      >
        <div className="input-control-container-right">{menus}</div>
      </div>
    );
  }

  const replyText = () => {
    if (state.replyVisible) {
      return (
        <div className="input-replay">
          <div
            className="action"
            clstag="pageclick|keycount|Xtbg_Msg|InfoCancelQuote"
            onClick={() => {
              dispatch({ type: "closeReply" });
              focus();
            }}
          >
            <IconFont className="icon-close" type="iconapp_btn_alert_cancel" />
          </div>
          <div className="sort-line" />
          <div className="reply-text">
            {getNameOrAlias()}
            <p
              className="dangerous-inner-html"
              dangerouslySetInnerHTML={{
                __html: state.replyText
              }}
            />
          </div>
        </div>
      );
    }
    return;
  };

  const isAIInputDisable = useMemo(() => {
    if (isAIChatSession(selectedSession)) {
      if (!lastMessage) {
        return false;
      }
      return !!lastMessage?.predictType && lastMessage?.flag !== "end" && !lastMessage?.isMyself;
    } else {
      return false;
    }
  }, [selectedSession, lastMessage]);
  useEffect(() => {
    enterAllowRef.current = llmFilesReady && !isAIInputDisable && hasContent;
  }, [llmFilesReady, isAIInputDisable, hasContent]);

  // 更换输入框内容
  function handleQuestionTabChange(item: any) {
    // setContent([{ insert: item.prompt || "" }, { insert: "\n" }]);
    questionTab.current = item;
  }

  function getAIChatRightMenu() {
    const menus: any[] = [];
    const settings = llmSetting?.settings?.filter((item: any) => {
      return !item?.isHide || item?.isHide !== 1;
    });
    menus.push(
      <QuestionTabs
        onChange={handleQuestionTabChange}
        disable={isAIInputDisable}
        setting={settings}
      />
    );
    return (
      <div className={`${!expand ? "" : "input-control-container-multRight"} `}>
        <div className="input-control-container-right border">{menus}</div>
      </div>
    );
  }

  // if (inputDisable) {
  //   return (
  //     <BannedInput
  //       currentEmployee={currentEmployee}
  //       selectedSession={selectedSession}
  //       config={config}
  //       divEl={divEl}
  //     />
  //   );
  // }

  function getNameOrAlias() {
    return (
      <div className="quote-name-alias">
        <span className="ellipsis">
          {t("input_quote_text")
            .replace("%name", (state.replyUser || {}).nickName || (state.replyUser || {}).name)
            .replace("%s", "")}
        </span>
        <ComGroupAlias user={state.replyUser} session={selectedSession} />：
      </div>
    );
  }

  const onCompositionStart = () => {
    console.log("onCompositionStart");
    isCompositionModeRef.current = true;
  };
  const onCompositionEnd = () => {
    isCompositionModeRef.current = false;
  };

  // 云文档
  const handleSendJoyspance = useCallback(() => {
    FocusSDK.sendToMain("ai:global:send_joyspace", {
      sessionId: selectedSession.sessionId
    });
  }, [selectedSession.sessionId]);
  // 智能助理文件选择
  const aiFileContentPop = useMemo(() => {
    return (
      <div className="ai-file-list-wrap">
        {/* 236暂时隐藏图片问答 */}
        {/* <div className="pop-item" onClick={() => handleImageClickAI()}>
          <IconFont type="iconic_app_im_picture" className="icon" />
          图片
        </div> */}
        <div className="pop-item" onClick={() => handleSendJoyspance()}>
          <IconFont type="iconwendangxietong1" className="icon" />
          文档协同
        </div>
        <div className="pop-item" onClick={() => handleFileClickAI()}>
          <IconFont type="iconbendiwenjian1" className="icon" />
          本地文件
          <Tooltip title={t1("AI.local-file-tip")}>
            <IconFont type="iconic_app_add_help" className="icon-tip" />
          </Tooltip>
        </div>
      </div>
    );
  }, [handleFileClick, handleSendJoyspance]);

  return (
    <div
      id="input-control-container"
      className={`input-control-container ${
        isAIChatSession(selectedSession)
          ? llmFiles?.length > 0 || llmImages?.length > 0
            ? "smallAI-files smallAI"
            : "smallAI"
          : ""
      } ${isAIInputDisable || inputDisable ? "input-control-container-disable" : ""}`}
      style={
        isAIInputDisable || inputDisable || isMeetingBanned || sessionFlag
          ? {
              //   opacity: 0.5,
              pointerEvents: "none"
            }
          : {}
      }
      ref={divEl}
      onKeyDown={handleKeyDown}
      onMouseLeave={isFocusEnv() ? closeContextMenu : undefined}
      onClick={(e) => {
        e.stopPropagation();
        closeSetting?.();
        setpasteVisible(false);
        setcopyVisible(false);
      }}
    >
      {isAIInputDisable ? <AIBannedInput /> : null}
      {quillModal && (
        <div
          className="mask-quill"
          style={{
            height: maskHeight.current,
            transform: `translateY(-${maskHeight.current})`
          }}
        />
      )}
      {saveRecordtip && (
        <div
          id="saveRecord"
          className="input-save-record"
          style={{
            position: "fixed",
            top: 25
          }}
        >
          <span>
            <img src={complete} style={{ marginRight: 8 }} />
            聊天记录已保存至协同文档，
          </span>
          <span
            style={{ textDecoration: "underline", cursor: "pointer" }}
            onClick={() => {
              FocusSDK.launchNewSession("/joyspace");
              setsaveRecordtip(false);
            }}
          >
            点击前往查看
          </span>
        </div>
      )}
      {[SessionType.MEETING_GROUP, SessionType.LIVE_MEETING_GROUP].includes(
        selectedSession.sessionType
      ) &&
        !isMeetingBanned &&
        !sessionFlags && (
          <div className="perchoose-container">
            <div>
              发送至
              <MembersPopover
                key="6"
                visible={state.listVisible}
                onVisibleChange={handlelistVisible}
                members={sessionMembers}
                listLen={meetingRosterLen}
              >
                <span className="member-list">
                  <span style={{ color: "#3A82FF" }}>{privateUser?.userName}</span>
                  {isShowmodal && <img src={arrow} style={{ cursor: "pointer" }} />}
                  {privateUser?.userName !== "所有人" && (
                    <span style={{ color: "#FF5E27" }}>（私聊）</span>
                  )}
                </span>
              </MembersPopover>
            </div>
            <div className="chat-perssion">
              {permissionText[(selectedSession?.settings?.permissionEnum || 0) as number]}
            </div>
          </div>
        )}
      {llmFiles?.length > 0 && <LLMFiles />}
      {llmImages?.length > 0 && <AIImagePanel />}
      <div className="input-line" id={isAIChatSession(selectedSession) ? "" : "input-line"} />
      {!llmFiles?.length &&
      !llmImages?.length &&
      isAIChatSession(selectedSession) &&
      llmSetting?.settings?.length
        ? getAIChatRightMenu()
        : null}
      <div className="input-contorl-box">
        {isFocusEnv() ? (
          <>
            <div className="input-copy-paste">
              {pasteVisible && (
                <>
                  {pasteTableImg && (
                    <div
                      className="paste-space_img"
                      onClick={(e) => {
                        doTableImgPaste(e);
                      }}
                    >
                      {t("paste-table_img")}
                    </div>
                  )}
                  <div
                    className="paste-space"
                    onClick={(e) => {
                      doPaste(e);
                    }}
                  >
                    {pasteTableImg ? t("paste-table_text") : t("paste")}
                  </div>
                </>
              )}
              {copyVisible && (
                <div
                  className="paste-copy"
                  onClick={(e) => {
                    doCopy(e);
                  }}
                >
                  {t("copy")}
                </div>
              )}
            </div>
            <div
              id="input-box-multiline"
              onContextMenu={isFocusEnv() ? onContextMenu : undefined}
              onMouseDown={isFocusEnv() ? doMouseDown : undefined}
              className="input-box input-box-multiline"
              style={
                expand || isAIInputDisable || isBanned || isMeetingBanned || sessionFlag
                  ? sessionFlag
                    ? { height: "100%", paddingBottom: "0" }
                    : {}
                  : {
                      width: `${!isAIChatSession(selectedSession) ? `${inputWidth}px` : "100%"}`
                    }
              }
            >
              {isMeetingBanned || inputDisable || sessionFlag ? (
                <div className="banSess">
                  {sessionFlag ? (
                    <div>
                      <IconFont className="icon-tip" type="iconic_pc_hint" />
                      {t("dismiss-input-tip")}
                    </div>
                  ) : isMeetingBanned ? (
                    "全体成员禁言"
                  ) : (
                    t("Group manager has been banned")
                  )}
                </div>
              ) : (
                <JEditor
                  contentChange={contentChange}
                  ref={inputRef}
                  upload={handleUploadImgs}
                  placeholder={placeholderText}
                  disableEnter={true}
                  onCompositionStart={onCompositionStart}
                  onCompositionEnd={onCompositionEnd}
                  selectedSession={selectedSession}
                  inputMenu={getRightMenu}
                  replyText={replyText}
                  // onEditorKeyDown={handleKeyDown}
                />
              )}
            </div>
          </>
        ) : (
          <div
            id="input-box-multiline"
            className="input-box input-box-multiline"
            style={
              expand || sessionFlag
                ? sessionFlag
                  ? { height: "100%", paddingBottom: "0" }
                  : {}
                : {
                    width: `${!isAIChatSession(selectedSession) ? `${inputWidth}px` : "100%"}`
                  }
            }
          >
            {inputDisable || sessionFlag || isMeetingBanned ? (
              <div className="banSess">
                {sessionFlag ? (
                  <div>
                    <IconFont className="icon-close" type="iconic_pc_hint" />
                    {t("dismiss-input-tip")}
                  </div>
                ) : isMeetingBanned ? (
                  "全体成员禁言"
                ) : (
                  t("Group manager has been banned")
                )}
              </div>
            ) : (
              <JEditor
                contentChange={contentChange}
                ref={inputRef}
                upload={handleUploadImgs}
                placeholder={placeholderText}
                disableEnter={true}
                onCompositionStart={onCompositionStart}
                onCompositionEnd={onCompositionEnd}
                selectedSession={selectedSession}
                inputMenu={getRightMenu}
                replyText={replyText}
              />
            )}
          </div>
        )}
        {/* {getRightMenu()} */}
        {config[ChatConfig.CHAT_MESSAGE_INPUT_AT] &&
          !selectedSession.isSingle &&
          inputRef.current && (
            <MentionUserPlugin
              editor={inputRef.current}
              members={sessionMembers}
              handleSearch={handleSearch}
              t={t}
              onVisibleChange={handleAtVisibleChange}
              isQuillModal={quillModal}
            />
          )}
        {!isLiveMeetingSessionId(selectedSession.sessionId) && (
          <UpLoadImg
            visible={state.imgUploadModalVisible}
            onCancel={closeUploadImgModal}
            onClick={sendImg}
            isMulti={isMulti}
            fileList={state.fileList}
            file={state.file}
            base64={state.imgState.base64}
            title={state.imgState.title}
            size={state.imgState.size}
            width={state.imgState.width}
            height={state.imgState.height}
            isShowTip={quillModal}
          />
        )}
        {/* 切换发送按钮 */}
        {![SessionType.MEETING_GROUP, SessionType.LIVE_MEETING_GROUP].includes(
          selectedSession.sessionType
        ) &&
          !isBanned &&
          !sessionFlags && (
            <div className={`enter-container ${isAIChatSession(selectedSession) ? "aichat" : ""}`}>
              {!isAIChatSession(selectedSession) && !quillModal && (
                <span className="enter-txt">
                  按{isenter === "" ? "Enter" : isenter}发送`消息，
                  {isctrl === "" ? "Ctrl + Enter" : isctrl}换行
                </span>
              )}
              {isAIChatSession(selectedSession) ? (
                <Popover
                  content={isAIInputDisable ? null : aiFileContentPop}
                  trigger="hover"
                  placement="topRight"
                  overlayClassName="ai-send-pop-popover"
                >
                  <IconFont className="btn-add" type="icona-ic_app_im_Addto" />
                </Popover>
              ) : null}
              <div className="enter-btn1">
                <Button
                  type="primary"
                  size="small"
                  block
                  onClick={doHandleSendmessage}
                  clstag={
                    quillModal
                      ? "pageclick|keycount|Xtbg_Msg_Info_MsgDialog|RichTextMessage_Send"
                      : "pageclick|keycount|Xtbg_Msg_Info_MsgDialog|Send"
                  }
                >
                  {isAIChatSession(selectedSession) ? (
                    <img
                      src={
                        llmFilesReady && !isAIInputDisable && hasContent ? sendActive : sendDisabled
                      }
                      className="send-icon"
                    />
                  ) : (
                    "发 送"
                  )}
                </Button>
              </div>
              {!isAIChatSession(selectedSession) && !quillModal && (
                <div className="enter-btn2">
                  <Space>
                    <Dropdown
                      overlay={renderEnterDropdownContextMenu}
                      trigger={["click"]}
                      placement="topRight"
                      onVisibleChange={(visible) => {
                        if (visible) {
                          analysisLog("Xtbg_Msg_Info_MsgDialog", "SendKey");
                        }
                      }}
                    >
                      <Button type="primary" size="small">
                        <DownOutlined />
                      </Button>
                    </Dropdown>
                  </Space>
                </div>
              )}
            </div>
          )}
      </div>
    </div>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(MessageInput);
